/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum SkillPermissionLevel {
  UseAndView = "useAndView",
  FullControl = "fullControl",
}

export enum SkillToolType {
  Native = "native",
  UserTool = "userTool",
}

export enum UserToolParameterDataType {
  String = "string",
  Number = "number",
  Boolean = "boolean",
  Enum = "enum",
}

export enum UserToolOwnershipFilter {
  Owned = "owned",
  Shared = "shared",
  Both = "both",
}

export enum ExtractionStatusValue {
  Pending = "pending",
  Completed = "completed",
  Failed = "failed",
}

export enum IndexingStatus {
  Pending = "pending",
  Completed = "completed",
  Failed = "failed",
  Stale = "stale",
}

export enum ExtractionStatus {
  Pending = "pending",
  Completed = "completed",
  Failed = "failed",
}

export enum MicrosoftCloudName {
  Commercial = "commercial",
  GccHigh = "gcc-high",
  Dod = "dod",
}

export enum IntegrationKind {
  MicrosoftOffice365 = "microsoft-office-365",
}

export enum ModelParameterScalarType {
  String = "string",
  Number = "number",
  Boolean = "boolean",
  Object = "object",
  Array = "array",
}

export enum MessageType {
  System = "system",
  UserInput = "userInput",
  ToolCall = "toolCall",
  ToolMessage = "toolMessage",
  ToolError = "toolError",
  LlmError = "llmError",
  Task = "task",
  IntermediateAnswer = "intermediateAnswer",
  FinalAnswer = "finalAnswer",
  FinalAnswerStream = "finalAnswerStream",
}

/**
 * Kind of resource a viewer is missing. Mirrors ShareAccessResourceType in
 * TeammateShareAccessService; declared locally so tsoa can emit it into the schema.
 */
export enum InaccessibleResourceType {
  Node = "node",
  UserTool = "userTool",
  Skill = "skill",
  SubTeammate = "subTeammate",
  Model = "model",
  Embedding = "embedding",
}

export enum ChatflowType {
  Agent = "agent",
  Pipeline = "pipeline",
  Playground = "playground",
}

export enum ChatflowOrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum ChatflowSortField {
  Name = "name",
  CreatedDate = "createdDate",
  UpdatedDate = "updatedDate",
}

export enum ChatFileUploadErrorCode {
  ExtractionFailed = "extraction_failed",
  NoReadableText = "no_readable_text",
  UploadFailed = "upload_failed",
}

/** The tool that produced a GeneratedFile. Null for files created before provenance was tracked. */
export enum ChatFileProvenance {
  CodeInterpreter = "codeInterpreter",
  DocxCreator = "docxCreator",
  PowerpointCreator = "powerpointCreator",
  ImageGenerator = "imageGenerator",
  WriteFile = "writeFile",
}

export enum ChatFileTypeParam {
  User = "user",
  Generated = "generated",
}

export enum MessageHistoryType {
  UserInput = "userInput",
  ToolCall = "toolCall",
  ToolMessage = "toolMessage",
  ToolError = "toolError",
  FinalAnswer = "finalAnswer",
  LlmError = "llmError",
}

export enum AuditLogOperation {
  Baseline = "baseline",
  Create = "create",
  Update = "update",
  Restore = "restore",
  Delete = "delete",
  Drift = "drift",
}

export enum AuditLogResourceType {
  Teammate = "teammate",
  Team = "team",
  Skill = "skill",
  UserTool = "user_tool",
  ApiKey = "api_key",
}

export enum AuditLogItemKind {
  Revision = "revision",
  Event = "event",
}

/**
 * Declared locally rather than imported from torqagent-services: tsoa cannot resolve types
 * across package boundaries. `bundleResourceTypeGuard` below keeps it honest against the
 * service's own union.
 */
export enum BundleResourceType {
  Teammate = "teammate",
  Skill = "skill",
  UserTool = "userTool",
}

export enum RevisionOperationName {
  Baseline = "baseline",
  Create = "create",
  Update = "update",
  Restore = "restore",
  Delete = "delete",
  Drift = "drift",
}

export enum RevisionRecordType {
  Teammate = "teammate",
  Team = "team",
  Skill = "skill",
  UserTool = "user_tool",
}

/** The `{type}` path segment. `user-tool` histories are keyed by the lineage parentId. */
export enum RevisionHistoryType {
  Teammate = "teammate",
  Team = "team",
  Skill = "skill",
  UserTool = "user-tool",
}

export enum PermissionLevel {
  Use = "use",
  UseAndView = "useAndView",
  FullControl = "fullControl",
}

export enum UsageMetricTimeRange {
  Last7Days = "last7Days",
  Last30Days = "last30Days",
  Last90Days = "last90Days",
  Custom = "custom",
}

export enum UsageMetricInterval {
  Hour = "hour",
  Day = "day",
  Week = "week",
  Range = "range",
}

export enum UsageMetricGroupBy {
  User = "user",
  Model = "model",
  Tool = "tool",
  ToolType = "toolType",
}

export enum UsageMetricName {
  TeammateCreated = "teammate_created",
  TeammateUserInput = "teammate_user_input",
  TeammateToolCall = "teammate_tool_call",
  UserToolCreated = "user_tool_created",
  TeamCreated = "team_created",
  TeamRun = "team_run",
}

export interface UsageMetricSeries {
  /** Group By value (user id, current model, tool name, tool type), `__unknown__` when missing, or `__total__` when ungrouped. */
  key: string;
  label: string;
  values: number[];
  /** @format double */
  total: number;
}

export interface UsageMetricsResponse {
  metric: UsageMetricName;
  groupBy: UsageMetricGroupBy | null;
  interval: UsageMetricInterval;
  cumulative: boolean;
  timeZone: string;
  /** Inclusive local date (YYYY-MM-DD). */
  startDate: string;
  /** Inclusive local date (YYYY-MM-DD). */
  endDate: string;
  /**
   * Local wall-clock start of each bucket (YYYY-MM-DDTHH:mm:ss) in `timeZone`. Weekly buckets start on
   * Monday, so the first and last can extend past `startDate` and `endDate` and count only the days
   * inside the range.
   */
  buckets: string[];
  /** One entry per Group By value, sorted by total descending. */
  series: UsageMetricSeries[];
}

export interface TemplateResponse {
  id: string;
  name: string;
  description: string;
  flowData: string;
  isRecommended: boolean;
  chatFlowType?: string;
  organizationId?: string;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
}

export type JsonPrimitive = string | number | boolean | null;

export type JsonValue = JsonPrimitive | JsonObject | JsonArray;

export type JsonObject = Record<string, JsonValue>;

export type JsonArray = JsonValue[];

/** Construct a type with a set of properties K of type T */
export type RecordStringJsonValue = Record<string, JsonValue>;

export interface Tool {
  id?: string;
  name: string;
  label?: string;
  usertool_id?: string;
  description: string;
  /** Construct a type with a set of properties K of type T */
  parameters?: RecordStringJsonValue;
  is_latest?: boolean;
  is_deleted?: boolean;
  latest_usertool_id?: string;
  is_deprecated?: boolean;
}

export interface AgentSettings {
  model_name: string;
  /** @format double */
  temperature?: number;
  teammate_instructions?: string;
  reasoning_level?: string;
  /** @format double */
  chat_history_length?: number;
  memory_ingest_enabled?: boolean;
  memory_ingest_responses_enabled?: boolean;
  disable_streaming?: boolean;
  /** @format double */
  max_iterations?: number;
  /** Construct a type with a set of properties K of type T */
  model_parameters?: RecordStringJsonValue;
}

export interface Agent {
  name: string;
  description?: string;
  /**
   * Playground teammates are hidden from the My Teammates list until they are converted.
   * Defaults to 'agent'.
   */
  type?: "agent" | "playground";
  tools?: Tool[];
  prompt_template: string;
  parameters: AgentSettings;
  /**
   * Exposes this Teammate's prediction endpoint to unauthenticated callers. Writing it requires the
   * `manage_agent_anonymous_access` permission; a request without it is rejected with 403.
   */
  allow_anonymous_access?: boolean;
  /**
   * User-defined labels for organizing Teammates, e.g. "production" or "dark web". On write, tags are
   * trimmed and de-duplicated case-insensitively; at most 20 tags of up to 50 characters each. On
   * update, omit the field to keep the stored tags and send `[]` to remove them all.
   */
  tags?: string[];
  /**
   * Response-only. Accepted and ignored on create and update, so a Teammate fetched from this API can
   * be sent back as is. To have an update checked against it, send it as `If-Match: "<revisionNo>"`.
   * @format double
   */
  revisionNo?: number;
}

export interface CreateTemplateRequest {
  name: string;
  description: string;
  flowData?: string;
  agent?: Agent;
  isRecommended?: boolean;
}

export interface TemplatePermissionResponse {
  action: string;
  resource: string;
  permitted: boolean;
}

export interface TemplateDeleteResponse {
  raw?: any;
  /** @format double */
  affected?: number | null;
}

export interface StringParameterResponse {
  type: "string";
  name: string;
}

export interface NumberParameterResponse {
  type: "number";
  name: string;
}

export interface BooleanParameterResponse {
  type: "boolean";
  name: string;
}

export interface EnumParameterResponse {
  type: "enum";
  name: string;
  enumValues: string[];
}

export type ParameterResponse =
  | StringParameterResponse
  | NumberParameterResponse
  | BooleanParameterResponse
  | EnumParameterResponse;

export interface NodeResponse {
  id: string;
  name: string;
  chatflowId: string;
  /**
   * Name of the referenced Teammate. Only populated on single-team responses (get/create/update);
   * list responses leave it undefined.
   */
  chatflowName?: string;
  /**
   * True when the referenced Teammate has been soft-deleted: the Team still runs it, but the UI
   * should flag it and the user should replace it. Only populated on single-team responses
   * (get/create/update); list responses leave it undefined.
   */
  chatflowIsDeleted?: boolean;
  prompt: string;
  requiresApproval: boolean;
  continueOnError: "None" | "ToolCalls" | "All";
  groupId: string | null;
}

export interface EdgeResponse {
  parentNodeId: string;
  childNodeId: string;
}

export interface GraphResponse {
  nodes: NodeResponse[];
  edges: EdgeResponse[];
}

export interface SharedUserResponse {
  email: string;
  permissionLevel: string;
}

export interface GroupResponse {
  id: string;
  name: string;
}

export interface TeamResponse {
  id: string;
  name: string;
  description: string;
  isPublic: boolean;
  isDeleted: boolean;
  parameters: ParameterResponse[];
  graph: GraphResponse;
  userId: string;
  userEmail: string;
  userName?: string;
  sharedWithUserEmails?: string[];
  sharedWithUsers?: SharedUserResponse[];
  sharedWithMe?: boolean;
  viewerPermissionLevel?: string;
  groups: GroupResponse[];
  outputTemplate: string;
  lastRun?: string;
  createdAt?: string;
  /**
   * The Team's current revision number. Send it back as `If-Match: "<revisionNo>"` on the next full save.
   * @format double
   */
  revisionNo: number;
}

export interface CreateTeamRequest {
  name: string;
  description: string;
  isPublic: boolean;
  parameters: ParameterResponse[];
  graph: GraphResponse;
  groups: GroupResponse[];
  userId?: string;
  outputTemplate: string;
}

export interface UpdateTeamRequest {
  userId?: string;
  name?: string;
  description?: string;
  isPublic?: boolean;
  parameters?: ParameterResponse[];
  graph?: GraphResponse;
  groups?: GroupResponse[];
  outputTemplate?: string;
}

export type TeamParameterValueType = string | number | boolean;

/** Construct a type with a set of properties K of type T */
export type RecordStringTeamParameterValueType = Record<
  string,
  TeamParameterValueType
>;

export interface TeamRunStepResponse {
  id: string;
  /** @format date-time */
  startedAt?: string;
  /** @format date-time */
  completedAt?: string;
  /** Null when the node was removed from the Team after the step ran (WF-2810). */
  nodeId: string | null;
  /** The node's name when the step ran; kept after the node is removed. */
  nodeName: string | null;
  /**
   * The Teammate revision the step's session ran.
   * @format double
   */
  chatflowRevisionNo: number | null;
  /**
   * The Team revision live when the step started.
   * @format double
   */
  teamRevisionNo: number | null;
  sessionId?: string;
  output?: string;
  error?: string;
  /** A tool error the Teammate recovered from on a node that continues on errors; the step still completed. */
  warning?: string;
  awaitingApproval: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface TeamRunResponse {
  id: string;
  teamId: string;
  teamName?: string;
  userId: string;
  /** @format date-time */
  startedAt: string | null;
  /** @format date-time */
  completedAt: string | null;
  status: "pending" | "running" | "waiting" | "completed" | "failed";
  /** Construct a type with a set of properties K of type T */
  arguments: RecordStringTeamParameterValueType;
  steps?: TeamRunStepResponse[];
  output?: string;
  /** @format date-time */
  updatedAt: string;
  /**
   * The Team revision the run was created (or last rerun) under (WF-2810). Null for older runs.
   * @format double
   */
  teamRevisionNo: number | null;
}

export type RunTeamRequest = Record<string, TeamParameterValueType>;

export interface RerunTeamFromNodeRequest {
  nodeId?: string;
}

export interface TeamListResponseApi {
  /** @format double */
  pageSize: number;
  /** @format double */
  pageNumber: number;
  /** @format double */
  numResults: number;
  teams: TeamResponse[];
}

export interface DeleteTeamResponse {
  success: boolean;
}

export interface ShareTeamRequest {
  email?: string;
  groupId?: string;
  permissionLevel?: PermissionLevel;
}

export interface TeamGroupShareResponse {
  groupId: string;
  name: string;
  permissionLevel: PermissionLevel;
}

export interface TeamGroupResponse {
  id: string;
  name: string;
  team?: {
    id: string;
  };
}

export interface CreateTeamGroupRequest {
  id?: string;
  name: string;
}

export interface TeamRunsResponse {
  runs: TeamRunResponse[];
  pagination: {
    /** @format double */
    totalCount: number;
    /** @format double */
    pageNumber: number;
    /** @format double */
    pageSize: number;
  };
}

export interface UpdateTeamRunStepOutputRequest {
  output: string;
}

export interface SessionResponse {
  userEmail?: string | null;
  userName?: string | null;
  userId?: string;
  /** @format date-time */
  latestMessageDate?: string | null;
  chatflowId: string;
  /** @format date-time */
  updatedDate: string;
  /** @format date-time */
  createdDate: string;
  title: string;
  id: string;
}

export interface CreateSessionRequest {
  title: string;
  chatflowId: string;
}

export interface UpdateSessionRequest {
  title: string;
}

export interface SecretResponse {
  organizationId: string;
  userId: string;
  name: string;
  id: string;
}

export interface CreateSecretRequest {
  name: string;
  value: string;
}

export interface PatchSecretRequest {
  name?: string;
  value?: string;
}

/** A JSON object, declared locally for tsoa. */
export type RevisionJsonObject = Record<string, any>;

export interface RevisionSecretMarkerResponse {
  set: boolean;
}

export interface RevisionDiffResponse {
  /** @format double */
  from: number;
  /** @format double */
  to: number;
  /** Dotted paths that differ, e.g. `agent.prompt_template` or `secrets.jira_0.apiToken.fp`. Layout-only changes produce none. */
  changedPaths: string[];
  fromProjection: RevisionJsonObject | null;
  toProjection: RevisionJsonObject | null;
  fromSecretMarkers: Record<string, RevisionSecretMarkerResponse>;
  toSecretMarkers: Record<string, RevisionSecretMarkerResponse>;
}

export interface RevisionAuditEventResponse {
  id: string;
  eventType: string;
  resourceType: string;
  resourceId: string;
  source: string;
  origin: string | null;
  actorUserId: string | null;
  actorEmail: string | null;
  actorApiKeyId: string | null;
  organizationId: string | null;
  relatedRevisionId: string | null;
  /** Full event details, including step output text for `team_run_step.output_edited`. */
  details: RevisionJsonObject;
  /** @format date-time */
  createdAt: string;
}

export interface RevisionEventsResponse {
  items: RevisionAuditEventResponse[];
  nextCursor: string | null;
}

export interface RevisionUpstreamChange {
  refType: RevisionRecordType;
  refId: string;
  userToolVersionId: string | null;
  name: string;
  /** @format double */
  savedRevisionNo: number;
  /** @format double */
  currentRevisionNo: number;
  lastEditorEmail: string | null;
  /** @format date-time */
  lastChangedAt: string | null;
}

export interface RevisionUpstreamChangesResponse {
  items: RevisionUpstreamChange[];
}

/** One revision's metadata (no snapshot). */
export interface RevisionSummaryResponse {
  id: string;
  resourceType: RevisionRecordType;
  resourceId: string;
  /** @format double */
  revisionNo: number;
  operation: RevisionOperationName;
  /** user | api_key | anonymous | runtime | system_sync | system_cleanup | bundle_import | backfill | drift_check */
  source: string;
  /** Client-asserted origin (user | assistant), informational only. */
  origin: string | null;
  actorUserId: string | null;
  actorEmail: string | null;
  actorApiKeyId: string | null;
  organizationId: string | null;
  changedPaths: string[];
  contentHash: string;
  /**
   * The If-Match value the save was based on.
   * @format double
   */
  parentRevisionNo: number | null;
  restoredFromRevisionId: string | null;
  /** hardDelete, restoreModified, refsAcknowledged, userToolVersionId, projectionError, reason */
  meta: RevisionJsonObject;
  /** @format double */
  snapshotSchemaVersion: number;
  /** @format date-time */
  createdAt: string;
}

export interface RevisionListResponse {
  items: RevisionSummaryResponse[];
  /**
   * Pass as `cursor` for the next (older) page.
   * @format double
   */
  nextCursor: number | null;
  /**
   * The resource's live revision number.
   * @format double
   */
  currentRevisionNo: number;
}

export interface RevisionRefResponse {
  type: RevisionRecordType;
  id?: string;
  /** @format double */
  revisionNo?: number;
  userToolVersionId?: string;
}

/** One revision with its redacted projection. Raw secrets are never returned. */
export interface RevisionDetailResponse {
  id: string;
  resourceType: RevisionRecordType;
  resourceId: string;
  /** @format double */
  revisionNo: number;
  operation: RevisionOperationName;
  /** user | api_key | anonymous | runtime | system_sync | system_cleanup | bundle_import | backfill | drift_check */
  source: string;
  /** Client-asserted origin (user | assistant), informational only. */
  origin: string | null;
  actorUserId: string | null;
  actorEmail: string | null;
  actorApiKeyId: string | null;
  organizationId: string | null;
  changedPaths: string[];
  contentHash: string;
  /**
   * The If-Match value the save was based on.
   * @format double
   */
  parentRevisionNo: number | null;
  restoredFromRevisionId: string | null;
  /** hardDelete, restoreModified, refsAcknowledged, userToolVersionId, projectionError, reason */
  meta: RevisionJsonObject;
  /** @format double */
  snapshotSchemaVersion: number;
  /** @format date-time */
  createdAt: string;
  /** The redacted v2 Agent (Teammate) or the normalized config (other types); null when it could not be built. */
  projection: RevisionJsonObject | null;
  /** Whether each redacted secret input (`<nodeId>.<input>`) was set. */
  secretMarkers: Record<string, RevisionSecretMarkerResponse>;
  refs: RevisionRefResponse[];
  /** @format double */
  fingerprintKeyVersion: number;
}

export interface RevisionDraftAgentTool {
  id?: string;
  name: string;
  label?: string;
  usertool_id?: string;
  description: string;
  /** A JSON object, declared locally for tsoa. */
  parameters?: RevisionJsonObject;
  is_latest?: boolean;
  is_deleted?: boolean;
  latest_usertool_id?: string;
  is_deprecated?: boolean;
}

export interface RevisionDraftAgentParameters {
  model_name: string;
  /** @format double */
  temperature?: number;
  teammate_instructions?: string;
  reasoning_level?: string;
  disable_streaming?: boolean;
  /** @format double */
  chat_history_length?: number;
  memory_ingest_enabled?: boolean;
  memory_ingest_responses_enabled?: boolean;
  /** @format double */
  max_iterations?: number;
  /** A JSON object, declared locally for tsoa. */
  model_parameters?: RevisionJsonObject;
}

/** The v2 Agent shape (as `GET /api/v2/public/teammates/{id}` returns it, without revisionNo). */
export interface RevisionDraftAgent {
  id: string;
  name: string;
  description?: string;
  type?: "agent" | "playground";
  tools?: RevisionDraftAgentTool[];
  prompt_template: string;
  parameters: RevisionDraftAgentParameters;
  allow_anonymous_access?: boolean;
}

export interface RevisionMissingSecret {
  /** The tool node id (Teammates), or the action's marker prefix such as `actions.call` (User Tools). */
  nodeId: string;
  /** The tool node name (Teammates), or the action name (User Tools). */
  toolName: string;
  /** The input (`apiToken`), or the path inside it or inside the action parameters (`headers.Authorization`). */
  input: string;
}

export interface RevisionUnavailableTool {
  nodeId: string;
  toolName: string;
  label: string | null;
}

export interface RevisionStaleToolVersion {
  /** The Teammate tool node; null for a Skill's tool list. */
  nodeId: string | null;
  userToolParentId: string;
  savedVersionId: string;
  latestVersionId: string;
  name: string;
  /** True when keepCurrentToolVersions rewrote the draft to the latest version. */
  rewritten: boolean;
}

export interface RevisionBrokenRef {
  refType: RevisionRecordType;
  /** The referenced id; for an inaccessible User Tool, the version id the revision saved. */
  refId: string;
  nodeId: string | null;
  /**
   * `deleted` only when the caller could see the resource and it is deleted; `inaccessible` for
   * everything else, including an id that does not exist or belongs to another organization.
   */
  reason: "deleted" | "inaccessible";
}

export interface RevisionRestoreDraftResponse {
  resourceType: RevisionRecordType;
  resourceId: string;
  /** @format double */
  revisionNo: number;
  /**
   * The live revision number; send it as If-Match on the Save that persists the draft.
   * @format double
   */
  currentRevisionNo: number;
  /** Teammates: the v2 Agent to load with resetTeammateFormValues. */
  agent: RevisionDraftAgent | null;
  /** Teams, Skills and User Tools: the normalized config the editor loads. */
  config: RevisionJsonObject | null;
  /**
   * Redacted secrets the draft could not refill from the live resource (the tool node or action is
   * gone or changed, or its live value is empty); they must be re-entered before saving.
   */
  missingSecrets: RevisionMissingSecret[];
  /** Retired tool types, dropped from the draft. */
  unavailableTools: RevisionUnavailableTool[];
  staleToolVersions: RevisionStaleToolVersion[];
  brokenRefs: RevisionBrokenRef[];
}

export interface BundleResourceRef {
  /**
   * Declared locally rather than imported from torqagent-services: tsoa cannot resolve types
   * across package boundaries. `bundleResourceTypeGuard` below keeps it honest against the
   * service's own union.
   */
  type: BundleResourceType;
  id: string;
}

export interface ExportBundleRequest {
  /** Resources to export. Their full reference closure is included automatically. */
  resources: BundleResourceRef[];
}

export interface ImportedResourceResponse {
  /**
   * Declared locally rather than imported from torqagent-services: tsoa cannot resolve types
   * across package boundaries. `bundleResourceTypeGuard` below keeps it honest against the
   * service's own union.
   */
  type: BundleResourceType;
  /** Id this resource had in the bundle. */
  sourceId: string;
  /** Id in this instance: new when created, unchanged when an existing resource was reused. */
  id: string;
  name: string;
  action: "created" | "reused";
}

export interface ImportBundleResponse {
  resources: ImportedResourceResponse[];
  roots: ImportedResourceResponse[];
  /**
   * Secrets the imported User Tools reference that this user does not have. The import still
   * succeeded; surfacing these at tool-invoke time is WF-2627.
   */
  missingSecretNames: string[];
}

export interface InvalidateUserPermissionsRequest {
  userId: string;
}

/** A JSON object, declared locally for tsoa. */
export type AuditLogJsonObject = Record<string, any>;

/** One org audit log entry: a config revision or a non-config audit event. Never a snapshot. */
export interface AuditLogItemResponse {
  kind: AuditLogItemKind;
  id: string;
  resourceType: AuditLogResourceType;
  resourceId: string;
  /**
   * The resource's current name: the live row's name, or the latest snapshot's name for a
   * hard-deleted resource. Null when unknown.
   */
  resourceName: string | null;
  /** True when the resource is soft-deleted or no longer exists. */
  resourceDeleted: boolean;
  /** `revision.<operation>` for revisions (e.g. `revision.update`), else the event type (e.g. `share.user.granted`). */
  eventType: string;
  /** The revision operation; null for events. */
  operation: AuditLogOperation | null;
  /**
   * The revision number; null for events.
   * @format double
   */
  revisionNo: number | null;
  /** user | api_key | anonymous | runtime | system_sync | system_cleanup | bundle_import | backfill | drift_check */
  source: string;
  /** Client-asserted origin (user | assistant), informational only. */
  origin: string | null;
  actorUserId: string | null;
  actorEmail: string | null;
  actorApiKeyId: string | null;
  /** The resource's organization at write time; null for an org-less resource. */
  organizationId: string | null;
  /** The actor's active organization at write time. */
  actorOrganizationId: string | null;
  /** Changed paths of a revision; empty for events. */
  changedPaths: string[];
  /**
   * A revision's `meta`, or an event's `details`, without values users typed:
   * - `team_run_step.output_edited`: `{runId, stepId, nodeName, outputBeforeLength, outputAfterLength,
   *   outputBeforeSha256, outputAfterSha256}`;
   * - `team_run.rerun`: `{runId, nodeId, nodeName, deletedSteps: [{stepId, nodeId, nodeName, outputLength,
   *   outputSha256}]}`;
   * - other Team run events: `{runId, stepId, nodeId, nodeName}`;
   * - `team_schedule.*`: `{scheduleId, changed, before, after}`, each side with `name, cronPattern,
   *   timezone, startAt, enabled, userId, hasDescription, argumentNames` (no description text or
   *   argument values).
   */
  details: AuditLogJsonObject;
  requestId: string | null;
  /** @format date-time */
  createdAt: string;
}

export interface AuditLogResponse {
  items: AuditLogItemResponse[];
  /** Pass as `cursor` for the next (older) page; null on the last page. */
  nextCursor: string | null;
}

export interface NodeOptionResponse {
  label: string;
  name: string;
  description?: string;
  isDeleted?: boolean;
}

/**
 * JSON-serializable value. Declared locally (mirroring torqagent-core's JsonValue) so TSOA can
 * resolve it for the generated spec without a cross-package model-name collision.
 */
export type NodeJsonValue =
  | string
  | number
  | boolean
  | Record<string, NodeJsonValue>
  | NodeJsonValue[]
  | null;

/**
 * A single node input parameter. Mirrors torqagent-core's `INodeParams` (declared locally so TSOA can
 * resolve it for the generated spec). `validationSchema` is serialized to a JSON schema in the response.
 */
export interface NodeInputParamResponse {
  label: string;
  name: string;
  type: string;
  default?: string | number | boolean | null;
  legacyDefault?: string | number | boolean | null;
  description?: string;
  subtext?: string;
  options?: NodeOptionResponse[];
  optional?: boolean | Record<string, string[] | string>;
  /** @format double */
  rows?: number;
  list?: boolean;
  multipleFiles?: boolean;
  /** @format double */
  maxFileCount?: number;
  /** @format double */
  min?: number;
  /** @format double */
  max?: number;
  /** @format double */
  step?: number;
  acceptVariable?: boolean;
  placeholder?: string;
  fileType?: string | string[];
  additionalParams?: boolean;
  isDynamic?: boolean;
  dynamicUpdateFunction?: string;
  dynamicUpdateFunctionArgs?: NodeJsonValue[];
  /**
   * JSON-serializable value. Declared locally (mirroring torqagent-core's JsonValue) so TSOA can
   * resolve it for the generated spec without a cross-package model-name collision.
   */
  validationSchema?: NodeJsonValue;
  showPromptImproveButton?: boolean;
  excludeFromUserTools?: boolean;
  overideOptions?: boolean;
  showWhen?: any;
  supportsDynamicRefresh?: boolean;
  dependsOnInputs?: string[];
}

export interface ToolkitToolTypeResponse {
  type: string;
  label: string;
  description: string;
  /**
   * JSON-serializable value. Declared locally (mirroring torqagent-core's JsonValue) so TSOA can
   * resolve it for the generated spec without a cross-package model-name collision.
   */
  schema: NodeJsonValue;
}

/**
 * A component node as returned to the UI. Mirrors `ResponseNode` from torqagent-services (declared
 * locally so TSOA can resolve the payload for the generated spec).
 */
export interface ComponentNodeResponse {
  category: string;
  name: string;
  label: string;
  description?: string;
  permissionResource?: string;
  isDeprecated?: boolean;
  permitted?: boolean;
  inputs?: NodeInputParamResponse[];
  modelsBlackList?: string[];
  modelsWhiteList?: string[];
  /**
   * JSON-serializable value. Declared locally (mirroring torqagent-core's JsonValue) so TSOA can
   * resolve it for the generated spec without a cross-package model-name collision.
   */
  toolInputSchema?: NodeJsonValue;
  toolTypes?: ToolkitToolTypeResponse[];
  toolName?: string;
  userToolId?: string;
}

export interface NodeInputOptionsRequest {
  inputs: Record<string, NodeJsonValue>;
  chatflowId?: string;
}

export interface ModelEvaluatorResult {
  status: "Passed" | "Failed";
  message?: string;
}

export interface ModelEvaluatorNodeInputParam {
  label: string;
  name: string;
  type: string;
}

export interface ModelEvaluatorNode {
  id: string;
  data: {
    inputParams?: ModelEvaluatorNodeInputParam[];
    inputs?: any;
    category?: string;
    label?: string;
    name: string;
    id: string;
  };
}

export interface ModelEvaluatorHistoryItem {
  value: string;
  type: MessageHistoryType;
}

export interface ModelEvaluatorTest {
  description?: string;
  flowData?: {
    nodes: ModelEvaluatorNode[];
  };
  tool: ModelEvaluatorNode;
  input: {
    history: ModelEvaluatorHistoryItem[];
    question: string;
  };
}

export interface RunModelEvaluatorRequest {
  model: string;
  test: ModelEvaluatorTest;
}

export interface ModelAcceptedMimeTypes {
  allSupportedTypes: string[];
  codeInterpreterTypes: string[];
  imageTypes: string[];
  textTypes: string[];
}

export interface ChatFileResponse {
  /** @format date-time */
  createdDate: string;
  /** The tool that produced a GeneratedFile. Null for files created before provenance was tracked. */
  provenance?: ChatFileProvenance | null;
  url?: string;
  /** @format double */
  order: number;
  contentType: string;
  /** @format double */
  fileSize: number;
  fileName: string;
  chatMessageId?: string;
  sessionId?: string | null;
  chatflowId: string;
  id: string;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringString = Record<string, string>;

/** Construct a type with a set of properties K of type T */
export type RecordStringChatFileUploadErrorCode = Record<
  string,
  ChatFileUploadErrorCode
>;

export interface CreateChatFilesResponse {
  /** Construct a type with a set of properties K of type T */
  errorCodes?: RecordStringChatFileUploadErrorCode;
  /** Construct a type with a set of properties K of type T */
  errors?: RecordStringString;
  created: ChatFileResponse[];
}

export interface ChatflowResponse {
  id: string;
  name: string;
  flowData: string;
  description?: string;
  chatFlowType?: string;
  allowAnonymousAccess?: boolean;
  apiConfig?: string;
  userId?: string;
  /** Display name of the Teammate's owner, or null when it could not be resolved. */
  userName?: string | null;
  /** Email of the Teammate's owner, or null when it could not be resolved. */
  userEmail?: string | null;
  organizationId?: string;
  isDeleted?: boolean;
  isSystem?: boolean;
  systemKey?: string | null;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  supportsVision?: {
    path: string[];
    nodeId: string;
  }[];
  supportsCodeInterpreter?: {
    path: string[];
    nodeId: string;
  }[];
  viewerPermissionLevel?: PermissionLevel;
  canViewAllSessions?: boolean;
  canDelete?: boolean;
  /**
   * The Teammate's current revision number. Send it back as `If-Match: "<revisionNo>"` on the next save.
   * @format double
   */
  revisionNo?: number;
  /** User-defined labels (WF-2820). */
  tags?: string[];
}

export interface ChatflowListResponse {
  /** @format double */
  pageSize: number;
  /** @format double */
  pageNumber: number;
  /** @format double */
  numResults: number;
  chatflows: ChatflowResponse[];
}

export interface ChatflowTagListResponse {
  /** @format double */
  pageSize: number;
  /** @format double */
  pageNumber: number;
  /** @format double */
  numResults: number;
  /** Distinct tags, ordered case-insensitively. */
  tags: string[];
}

export interface CreateChatflowRequest {
  name: string;
  description?: string;
  flowData: string;
  allowAnonymousAccess?: boolean;
}

export interface UpdateChatflowRequest {
  name?: string;
  description?: string;
  flowData?: string;
  allowAnonymousAccess?: boolean;
}

export interface ChatflowStreamableResponse {
  isStreaming: boolean;
}

export interface AssociatedTeamsResponse {
  teams: {
    name: string;
    id: string;
  }[];
}

export interface InaccessibleResource {
  /**
   * Kind of resource a viewer is missing. Mirrors ShareAccessResourceType in
   * TeammateShareAccessService; declared locally so tsoa can emit it into the schema.
   */
  type: InaccessibleResourceType;
  /** Display name. Falls back to the permission codename when the resource has no better name. */
  name: string;
  /** Row id, set for user tools, skills and sub-teammates; absent for node and provider permissions. */
  id?: string;
}

export interface InaccessibleResourcesResponse {
  resources: InaccessibleResource[];
}

/**
 * A resource the share recipient cannot see. Mirrors torqagent-services' MissingShareResource
 * (declared locally so TSOA can resolve it for the generated spec).
 */
export interface MissingShareResourceResponse {
  type: "node" | "userTool" | "skill" | "subTeammate" | "model" | "embedding";
  name: string;
  id?: string;
}

/**
 * The result of sharing a Teammate. `permissionLevel` is what was actually granted: a write
 * share to a user who cannot see the whole Teammate is granted read-only instead, with
 * `downgraded` set and `warnings` explaining why (WF-2673).
 */
export interface ShareChatflowResponse {
  id: string;
  /** Set for a user share; absent for a group share. */
  userId?: string;
  /** Set for a group share; absent for a user share. */
  groupId?: string;
  permissionLevel: PermissionLevel;
  requestedPermissionLevel: PermissionLevel;
  downgraded: boolean;
  warnings: string[];
  missingResources: MissingShareResourceResponse[];
}

/**
 * Failure shape of a share attempt (mirrors torqagent-services' ChatFlowServiceErrorReturn,
 * declared locally so TSOA can resolve it for the generated spec). The status code is set on
 * the response; `code` repeats it in the body as the service returns it.
 */
export interface ShareChatflowErrorResponse {
  error: string;
  path?: string;
  /** @format double */
  code: number;
}

export interface ShareChatflowRequest {
  email?: string;
  groupId?: string;
  permissionLevel?: PermissionLevel;
}

export interface ChatflowSharedUserResponse {
  email: string;
  permissionLevel: PermissionLevel;
}

export interface ChatflowSharedGroupResponse {
  groupId: string;
  name: string;
  permissionLevel: PermissionLevel;
}

/**
 * Mirrors torqagent-services' ChatMessageFeedbackResponse (declared locally so TSOA can resolve it
 * for the generated spec).
 */
export interface ChatMessageFeedbackResponse {
  id: string;
  messageId: string;
  text: string | null;
  value: "approved" | "disapproved" | null;
  /** @format date-time */
  timestamp: string;
}

export interface ChatMessageRuntimeContext {
  skills: {
    /** @format double */
    revisionNo: number;
    skillId: string;
  }[];
  subTeammates: {
    /** @format double */
    revisionNo: number;
    chatflowId: string;
  }[];
  disabledTools: {
    subTools?: string[];
    nodeId: string;
  }[];
  memoryEnabled: boolean;
}

export interface ChatMessageResponse {
  /** The turn's resolved Skills, Sub-Teammates, disabled tools and memory flag. Set on user input, final answer and error messages. */
  runtimeContext: ChatMessageRuntimeContext | null;
  /**
   * The Teammate revision this turn ran (WF-2810). 0 before the Teammate's first revision; null on older messages.
   * @format double
   */
  configRevisionNo: number | null;
  /**
   * Mirrors torqagent-services' ChatMessageFeedbackResponse (declared locally so TSOA can resolve it
   * for the generated spec).
   */
  feedback?: ChatMessageFeedbackResponse;
  chatFiles?: ChatFileResponse[];
  childChatflowName?: string;
  childChatflowId?: string;
  childSessionId?: string;
  pendingBackground: boolean;
  pendingApproval: boolean;
  errorCode?: string;
  /** @format date-time */
  createdDate: string;
  content: string;
  sessionId?: string;
  chatflowId: string;
  role: MessageType;
  id: string;
}

export interface CreateChatflowMessageRequest {
  role?: MessageType;
  content: string;
  files?: string[];
  chatSessionId?: string;
}

export interface DeleteMessagesResponse {
  /** @format double */
  affected?: number | null;
}

export interface ToolCallResolutionResponse {
  /** The turn's resolved Skills, Sub-Teammates, disabled tools and memory flag. Set on user input, final answer and error messages. */
  runtimeContext: ChatMessageRuntimeContext | null;
  /**
   * The Teammate revision this turn ran (WF-2810). 0 before the Teammate's first revision; null on older messages.
   * @format double
   */
  configRevisionNo: number | null;
  /**
   * Mirrors torqagent-services' ChatMessageFeedbackResponse (declared locally so TSOA can resolve it
   * for the generated spec).
   */
  feedback?: ChatMessageFeedbackResponse;
  chatFiles?: ChatFileResponse[];
  childChatflowName?: string;
  childChatflowId?: string;
  childSessionId?: string;
  pendingBackground: boolean;
  pendingApproval: boolean;
  errorCode?: string;
  /** @format date-time */
  createdDate: string;
  content: string;
  sessionId?: string;
  chatflowId: string;
  role: MessageType;
  id: string;
  approvalContinuationStarted: boolean;
}

export interface ApproveToolCallRequest {
  socketIOClientId?: string;
}

export interface RejectToolCallRequest {
  reason?: string;
}

export interface CancelSubTeammateRequest {
  reason?: string;
}

export interface SubTeammateFollowUpRequest {
  message: string;
}

export interface SaveFeedbackResponse {
  id: string;
}

export interface ChatMessageFeedbackRequest {
  text?: string | null;
  value?: "approved" | "disapproved" | null;
  timestamp?: string | null;
}

export interface QueuedPredictionResponse {
  sessionId: string;
  messageId: string;
  /** @format double */
  sequence: number;
  status:
    | "receiving"
    | "processing_files"
    | "queued"
    | "dispatching"
    | "running"
    | "waiting_for_approval"
    | "waiting_for_background"
    | "completed"
    | "failed"
    | "cancelled";
}

export interface ChatFileReference {
  id: string;
  fileName?: string;
  /** @format double */
  fileSize?: number;
  contentType?: string;
  /** @format double */
  order?: number;
}

export interface InternalPredictionHistoryMessage {
  type: MessageType;
  value: string;
  toolName?: string;
  files?: string[];
  data?: {
    tool?: {
      id?: string;
      label?: string;
      name?: string;
    };
    parentRunId?: string;
    runId?: string;
    [key: string]: any;
  };
  chatFiles?: ChatFileReference[];
}

/** Construct a type with a set of properties K of type T */
export type RecordStringAny = Record<string, any>;

/** Ephemeral per-request tool suppression, keyed by flow node id. */
export interface InternalPredictionDisabledTool {
  nodeId: string;
  subTools?: string[];
}

export interface InternalPredictionInput {
  question: string;
  approvalContinuation?: boolean;
  backgroundContinuation?: boolean;
  files?: string[];
  chatFiles?: ChatFileReference[];
  history?: InternalPredictionHistoryMessage[];
  /** Construct a type with a set of properties K of type T */
  promptVariables?: RecordStringAny;
  stateful?: boolean;
  sessionId?: string;
  videoEnabled?: boolean;
  disabledTools?: InternalPredictionDisabledTool[];
}

export interface PublicPredictionMessage {
  type: MessageType;
  value: string;
  toolName?: string;
  files: string[];
}

export interface PublicPredictionInput {
  question: string;
  history?: PublicPredictionMessage[];
  stateful?: boolean;
  sessionId?: string;
}

export interface MemoryTeammateAttribution {
  id: string;
  name: string | null;
}

export interface MemoryResponse {
  id: string;
  memory: string;
  /** @format double */
  score: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  teammate: MemoryTeammateAttribution | null;
}

export interface MemoryListPagination {
  /** @format double */
  pageSize: number;
  /** @format double */
  pageNumber: number;
  /** @format double */
  totalCount: number;
}

export interface MemoryListResponse {
  memories: MemoryResponse[];
  pagination: MemoryListPagination;
}

export interface MemoryGraphRelationResponse {
  source: string;
  relationship: string;
  target: string;
  sourceType: string | null;
  targetType: string | null;
}

export interface MemoryGraphResponse {
  relations: MemoryGraphRelationResponse[];
}

export interface UpdateMemoryResponse {
  message: string;
}

export interface UpdateMemoryRequest {
  memory: string;
}

export interface DeleteMemoryResponse {
  message: string;
}

/**
 * Description of a single tunable model parameter. Declared locally (mirroring
 * torqagent-langchain's ModelParameterDescriptor) so TSOA can resolve it for the generated spec.
 */
export interface ModelParameterDescriptor {
  items?: {
    enum?: string[];
    type: ModelParameterScalarType;
  };
  enum?: string[];
  nullable?: boolean;
  type: ModelParameterScalarType;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringModelParameterDescriptor = Record<
  string,
  ModelParameterDescriptor
>;

export interface LanguageModelResponse {
  iconUrl?: string;
  /** Construct a type with a set of properties K of type T */
  modelParameters?: RecordStringModelParameterDescriptor;
  streamingToolUse: boolean;
  supportsStreaming: boolean;
  supportsCodeInterpreter: boolean;
  supportsTemperature: boolean;
  supportsVision: boolean;
  autoUpgrade?: string;
  modelSystemPrompt?: string;
  reasoningLevelType?: string | null;
  /** @format double */
  maxOutputTokens?: number;
  /** @format date-time */
  updatedDate: string;
  /** @format date-time */
  createdDate: string;
  isDefault: boolean;
  isDeleted: boolean;
  region?: string;
  node: string;
  type: string;
  description?: string;
  label: string;
  model: string;
}

export interface CrawlStatusEntry {
  knowledgeBaseWebsiteId: string;
  name: string;
  rootUrl: string;
  /** @format double */
  latestVersion: number;
  latestCrawlStatus: string | null;
  /** @format double */
  pageCrawled: number;
  hasPendingCrawl: boolean;
}

export interface CrawlStatusResponse {
  websites: CrawlStatusEntry[];
}

export interface IntegrationConfigurationResponse {
  id?: string;
  organizationId?: string;
  kind: IntegrationKind;
  /** Where the credentials in `data` came from. `global` implies `inheritGlobal`. */
  source: "organization" | "global";
  /**
   * True when this organization has deliberately opted into the deployment-wide configuration
   * rather than supplying its own credentials. An organization with no row at all is simply not
   * configured and is reported as a 404. (WF-2657)
   */
  inheritGlobal: boolean;
  routingToken?: string;
  data: {
    cloud?: MicrosoftCloudName;
    clientSecret: string;
    tenantId: string;
    applicationId: string;
  };
}

export interface CreateIntegrationConfigurationRequest {
  kind: IntegrationKind;
  /**
   * Opt into the deployment-wide configuration instead of supplying credentials. When true the
   * credential fields must be omitted; when false or absent they are all required.
   */
  inheritGlobal?: boolean;
  applicationId?: string;
  tenantId?: string;
  clientSecret?: string;
  cloud?: MicrosoftCloudName;
}

export interface PatchIntegrationConfigurationRequest {
  /**
   * Switch the organization between inheriting the deployment-wide configuration and using its own
   * credentials. Switching off inheriting requires the full credential set in the same request,
   * since an inheriting row has none stored to merge into.
   */
  inheritGlobal?: boolean;
  applicationId?: string;
  tenantId?: string;
  clientSecret?: string;
  cloud?: MicrosoftCloudName;
}

export interface IntegrationAuthorizationResponse {
  kind: IntegrationKind;
  expiresAt: string;
  expired: boolean;
}

export interface AuthorizationUrlResponse {
  authorizationUrl: string;
  state: string;
}

export interface CompleteAuthorizationRequest {
  kind: IntegrationKind;
  code: string;
}

export interface UserDocumentResponse {
  id: string;
  file_path: string;
  name: string;
  type: string;
  contentHash: string;
  extractedFilePath?: string | null;
  extractionStatus?: ExtractionStatus | null;
  extractionError?: string | null;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
}

export interface DocumentCollectionResponse {
  id: string;
  userId?: string | null;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  documents?: UserDocumentResponse[];
}

export interface VectorizationConfigInput {
  enableVectorSearch?: boolean | string | null;
  embeddingsType?: string | null;
  chunkingPreset?: string | null;
  usage?: string | null;
  chunkSize?: string | number | null;
  chunkOverlap?: string | number | null;
  columnName?: string | null;
}

export interface CreateDocumentCollectionRequest {
  params?: {
    vectorizationConfig?: VectorizationConfigInput;
  };
}

export interface DocumentStatusResponse {
  id: string;
  name: string;
  type: string;
  extractionStatus: ExtractionStatus | null;
  extractionError: string | null;
  indexingStatus: IndexingStatus;
  isUserEdited: boolean;
}

export interface ExtractedTextResponse {
  docId: string;
  content: string;
  extractionStatus: ExtractionStatusValue;
  /** @format date-time */
  updatedDate: string;
}

export interface UpdateExtractedTextResponse {
  docId: string;
  extractedFilePath: string;
  extractionStatus: ExtractionStatusValue;
  /** @format date-time */
  updatedDate: string;
}

export interface UpdateExtractedTextRequest {
  content: string;
}

export interface ChatflowIntegrationResponse {
  id: string;
  chatflowId: string;
  organizationId: string;
  kind: IntegrationKind;
}

export interface ApiKeyResponse {
  id: string;
  keyName: string;
  apiKeyPrefix: string;
  userId: string;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  organizationId: string | null;
  /** Granted scopes, exactly as chosen: a `<group>:all` is stored rather than expanded. */
  scopes: string[];
  /** A fine-grained key reaches only the Teammates and Teams below, and cannot create anything. */
  isFineGrained: boolean;
  /** Only populated for a fine-grained key. */
  teammateIds: string[];
  /** Only populated for a fine-grained key. */
  teamIds: string[];
}

export interface CreateApiKeyResponse {
  id: string;
  keyName: string;
  apiKeyPrefix: string;
  userId: string;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  organizationId: string | null;
  /** Granted scopes, exactly as chosen: a `<group>:all` is stored rather than expanded. */
  scopes: string[];
  /** A fine-grained key reaches only the Teammates and Teams below, and cannot create anything. */
  isFineGrained: boolean;
  /** Only populated for a fine-grained key. */
  teammateIds: string[];
  /** Only populated for a fine-grained key. */
  teamIds: string[];
  /** The plaintext API key. Only returned once, at creation time. */
  apiKey: string;
}

export interface CreateApiKeyRequest {
  keyName: string;
  /**
   * Scopes to grant. Omitted means every `<group>:all` — what an unscoped key has always had, and
   * what keeps existing API clients working when they were written before scopes existed.
   */
  scopes?: string[];
  /** Restrict the key to the Teammates and Teams named below. Defaults to a global key. */
  isFineGrained?: boolean;
  teammateIds?: string[];
  teamIds?: string[];
}

export interface UpdateApiKeyRequest {
  keyName?: string;
  scopes?: string[];
  isFineGrained?: boolean;
  teammateIds?: string[];
  teamIds?: string[];
}

/** Construct a type with a set of properties K of type T */
export type RecordStringNever = object;

export type DeleteApiKeyResponse = RecordStringNever;

export interface UserToolParameter {
  id: string;
  name: string;
  datatype: "string" | "number" | "boolean" | "enum";
  enumValues?: string[];
  /**
   * Wrapper type for relation type definitions in entities.
   * Used to circumvent ESM modules circular dependency issue caused by reflection metadata saving the type of the property.
   *
   * Usage example:
   */
  userTool: RelationUserTool;
}

/**
 * Wrapper type for relation type definitions in entities.
 * Used to circumvent ESM modules circular dependency issue caused by reflection metadata saving the type of the property.
 *
 * Usage example:
 */
export type RelationUserTool = UserTool;

export interface UserToolUser {
  id: string;
  userId: string;
  permissionLevel: PermissionLevel;
  /**
   * Wrapper type for relation type definitions in entities.
   * Used to circumvent ESM modules circular dependency issue caused by reflection metadata saving the type of the property.
   *
   * Usage example:
   */
  userTool: RelationUserTool;
}

export interface UserToolGroup {
  id: string;
  groupId: string;
  permissionLevel: PermissionLevel;
  /**
   * Wrapper type for relation type definitions in entities.
   * Used to circumvent ESM modules circular dependency issue caused by reflection metadata saving the type of the property.
   *
   * Usage example:
   */
  userTool: RelationUserTool;
}

export interface UserToolAction {
  id: string;
  name: string;
  type: string;
  parameters: JsonValue;
  /** @format date-time */
  createdDate: string;
  /** @format double */
  order: number;
  /** @format date-time */
  updatedDate: string;
  /**
   * Wrapper type for relation type definitions in entities.
   * Used to circumvent ESM modules circular dependency issue caused by reflection metadata saving the type of the property.
   *
   * Usage example:
   */
  userTool: RelationUserTool;
}

export interface UserTool {
  id: string;
  parentId: string;
  name: string;
  description: string;
  outputValue: string;
  isPublic: boolean;
  userId: string;
  isLatest: boolean;
  parameters: UserToolParameter[];
  sharedWithUserIds: UserToolUser[];
  sharedWithGroupIds: UserToolGroup[];
  actions: UserToolAction[];
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  isDeleted: boolean;
  organizationId?: string;
}

export interface UserToolSummary {
  id: string;
  parentId: string;
  name: string;
  description: string;
  isPublic: boolean;
  userId: string;
  organizationId?: string;
  isLatest: boolean;
  parameters: UserToolParameter[];
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  isDeleted: boolean;
  /**
   * When the tool's first version was created. `createdDate` is when this version was saved.
   * @format date-time
   */
  originalCreatedDate?: string;
  /** Display name of the tool's owner, or null when it could not be resolved. */
  userName?: string | null;
  /** Email of the tool's owner, or null when it could not be resolved. */
  userEmail?: string | null;
  viewerPermissionLevel?: PermissionLevel;
}

export interface UserToolResponseParameter {
  id: string;
  name: string;
  datatype: UserToolParameterDataType;
  enumValues?: string[];
}

export interface UserToolResponseAction {
  id: string;
  name: string;
  type: string;
  /** @format double */
  order: number;
  /** Construct a type with a set of properties K of type T */
  parameters: RecordStringAny;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
}

export interface UserToolResponseUser {
  id: string;
  userId: string;
  permissionLevel: PermissionLevel;
}

export interface UserToolResponse {
  id: string;
  parentId: string;
  name: string;
  description: string;
  isPublic: boolean;
  userId: string;
  organizationId?: string;
  isLatest: boolean;
  parameters: UserToolResponseParameter[];
  actions: UserToolResponseAction[];
  sharedWithUserIds: UserToolResponseUser[];
  outputValue: string;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  isDeleted: boolean;
  /**
   * When the tool's first version was created. `createdDate` is when this version was saved.
   * @format date-time
   */
  originalCreatedDate?: string;
  /** Display name of the tool's owner, or null when it could not be resolved. */
  userName?: string | null;
  /** Email of the tool's owner, or null when it could not be resolved. */
  userEmail?: string | null;
  viewerPermissionLevel?: PermissionLevel;
  /** @format double */
  revisionNo: number;
}

export interface NewUserToolParameter {
  name: string;
  datatype: UserToolParameterDataType;
  enumValues?: string[];
}

export interface NewUserToolAction {
  name: string;
  type: string;
  /** Construct a type with a set of properties K of type T */
  parameters: RecordStringAny;
}

export interface CreateUserToolRequest {
  name: string;
  description: string;
  parameters?: NewUserToolParameter[];
  actions?: NewUserToolAction[];
  outputValue?: string;
  isPublic?: boolean;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringUnknown = Record<string, any>;

export interface TestActionInput {
  action: NewUserToolAction;
  /** Construct a type with a set of properties K of type T */
  inputs: RecordStringUnknown;
  userToolId?: string;
}

export interface UserToolActionType {
  type: string;
  label: string;
  iconUrl: string;
  isNative: boolean;
  permitted?: boolean;
}

export interface UserToolUpdateParameter {
  id?: string;
  name: string;
  datatype: UserToolParameterDataType;
  enumValues?: string[];
}

export interface UserToolUpdateAction {
  id?: string;
  name: string;
  type: string;
  /** Construct a type with a set of properties K of type T */
  parameters: RecordStringAny;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface NewUserToolVersionRequest {
  id?: string;
  parentId?: string;
  name?: string;
  description?: string;
  parameters?: UserToolUpdateParameter[];
  actions?: UserToolUpdateAction[];
  outputValue?: string;
  isPublic?: boolean;
}

export interface RenameUserToolRequest {
  name: string;
  description?: string;
}

export interface UserToolActionResponse {
  id: string;
  name: string;
  type: string;
  /** Construct a type with a set of properties K of type T */
  parameters: RecordStringAny;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  /** @format double */
  order: number;
}

export interface UserToolErrorResponse {
  id: string;
  message: string;
  details: JsonObject;
  /** @format date-time */
  createdDate: string;
  userToolAction: UserToolActionResponse;
}

export interface NewUserToolShare {
  email?: string;
  groupId?: string;
  permissionLevel?: PermissionLevel;
}

export interface UserToolShare {
  email: string;
  userId: string;
  permissionLevel: PermissionLevel;
}

export interface UserToolGroupShare {
  groupId: string;
  name: string;
  permissionLevel: PermissionLevel;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringStringOrNumberOrBoolean = Record<
  string,
  string | number | boolean
>;

export interface TeamScheduleResponse {
  id: string;
  teamId: string;
  teamName: string;
  name: string;
  description: string | null;
  cronPattern: string;
  timezone: string | null;
  startAt: string | null;
  arguments: RecordStringStringOrNumberOrBoolean | null;
  enabled: boolean;
  userId: string;
  createdAt: string;
  updatedAt: string;
  lastRunId: string | null;
  lastRunAt: string | null;
  nextRunAt: string | null;
}

export interface CreateTeamScheduleRequest {
  name: string;
  description?: string | null;
  cronPattern: string;
  timezone?: string | null;
  startAt?: string | null;
  arguments?: RecordStringStringOrNumberOrBoolean | null;
}

export interface TeamScheduleListResponse {
  schedules: TeamScheduleResponse[];
  pagination: {
    /** @format double */
    totalCount: number;
    /** @format double */
    pageNumber: number;
    /** @format double */
    pageSize: number;
  };
}

export interface UpdateTeamScheduleRequest {
  name?: string;
  description?: string | null;
  cronPattern?: string;
  timezone?: string | null;
  startAt?: string | null;
  arguments?: RecordStringStringOrNumberOrBoolean | null;
  enabled?: boolean;
}

export interface SkillUserToolAccessResponse {
  name: string;
  description: string;
  toolName: string;
  accessible: boolean;
  deleted: boolean;
}

export interface SkillToolResponse {
  id: string;
  toolType: SkillToolType;
  userToolId?: string;
  toolName?: string;
  userToolAccess?: SkillUserToolAccessResponse;
}

export interface SkillSharedUserResponse {
  id: string;
  userId: string;
  permissionLevel: SkillPermissionLevel;
}

export interface SkillSummaryResponse {
  id: string;
  name: string;
  description: string;
  userId: string;
  /** Display name of the Skill's owner. Only populated by the list and get endpoints; null when it could not be resolved. */
  userName?: string | null;
  /** Email of the Skill's owner. Only populated by the list and get endpoints; null when it could not be resolved. */
  userEmail?: string | null;
  isPublic: boolean;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  tools: SkillToolResponse[];
  sharedWithUsers: SkillSharedUserResponse[];
  isSystem?: boolean;
  systemKey?: string | null;
}

export interface SkillResponse {
  id: string;
  name: string;
  description: string;
  userId: string;
  /** Display name of the Skill's owner. Only populated by the list and get endpoints; null when it could not be resolved. */
  userName?: string | null;
  /** Email of the Skill's owner. Only populated by the list and get endpoints; null when it could not be resolved. */
  userEmail?: string | null;
  isPublic: boolean;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  tools: SkillToolResponse[];
  sharedWithUsers: SkillSharedUserResponse[];
  isSystem?: boolean;
  systemKey?: string | null;
  body: string;
  /**
   * The Skill's current revision number. Send it back as `If-Match: "<revisionNo>"` on the next full save.
   * @format double
   */
  revisionNo: number;
  viewerPermissionLevel?: SkillPermissionLevel;
}

export interface SkillTool {
  toolType: SkillToolType;
  userToolId?: string;
  toolName?: string;
}

export interface SkillSharedUser {
  userId: string;
  permissionLevel?: SkillPermissionLevel;
}

export interface CreateSkillRequest {
  name: string;
  description: string;
  body: string;
  isPublic?: boolean;
  tools?: SkillTool[];
  sharedWithUsers?: SkillSharedUser[];
}

export interface UpdateSkillRequest {
  name?: string;
  description?: string;
  body?: string;
  isPublic?: boolean;
  tools?: SkillTool[];
  sharedWithUsers?: SkillSharedUser[];
}

export interface ShareSkillRequest {
  email?: string;
  groupId?: string;
  permissionLevel?: SkillPermissionLevel;
}

export interface UnShareSkillRequest {
  email?: string;
  groupId?: string;
}

export interface SkillGroupShare {
  groupId: string;
  name: string;
  permissionLevel: SkillPermissionLevel;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/api/v1";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title torqagent-server
 * @version 1.2.15
 * @license UNLICENSED
 * @baseUrl /api/v1
 * @contact IntelliBridge
 *
 * TorqAgent Server
 */
export class InternalApi<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  webhooks = {
    /**
     * @description POST /api/v1/webhooks/firecrawl — Firecrawl crawl event receiver. Always acknowledges with 200 (except an unauthorized 401) so Firecrawl does not retry payloads we cannot or need not process.
     *
     * @tags Webhooks
     * @name FirecrawlWebhook
     * @request POST:/webhooks/firecrawl
     */
    firecrawlWebhook: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/webhooks/firecrawl`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  usageMetrics = {
    /**
     * @description Usage counts for the caller's active organization, bucketed by time interval and optionally split into one series per Group By value. Requires the view_organization_usage organization permission.
     *
     * @tags Usage Metrics
     * @name GetUsageMetrics
     * @request GET:/usage-metrics
     * @secure
     */
    getUsageMetrics: (
      query: {
        /** The usage metric to report. */
        metric: UsageMetricName;
        /** IANA time zone for calendar ranges and bucket boundaries, e.g. America/New_York. */
        timeZone: string;
        /** Time range. `custom` requires startDate and endDate. */
        range?: UsageMetricTimeRange;
        /** Bucket size. `range` returns a single bucket covering the whole range. */
        interval?: UsageMetricInterval;
        /** Splits counts into one series per value. Allowed values depend on the metric. */
        groupBy?: UsageMetricGroupBy;
        /** Report running totals from the start of the range. Ignored for the `range` interval. */
        cumulative?: boolean;
        /** Inclusive start date (YYYY-MM-DD) of a custom range. */
        startDate?: string;
        /** Inclusive end date (YYYY-MM-DD) of a custom range. */
        endDate?: string;
        /** Only count usage by these users. */
        userIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<UsageMetricsResponse, any>({
        path: `/usage-metrics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  templates = {
    /**
     * @description List agent templates available to the authenticated user (filtered by their organization).
     *
     * @tags Templates
     * @name GetTemplates
     * @request GET:/templates
     * @secure
     */
    getTemplates: (
      query?: {
        sort?: string[];
        filter?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TemplateResponse[], any>({
        path: `/templates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new agent template. File-upload and document-collection inputs are stripped from the stored flowData.
     *
     * @tags Templates
     * @name CreateTemplate
     * @request POST:/templates
     * @secure
     */
    createTemplate: (data: CreateTemplateRequest, params: RequestParams = {}) =>
      this.request<TemplateResponse, any>({
        path: `/templates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Whether the authenticated user may create templates.
     *
     * @tags Templates
     * @name TemplatePermissions
     * @request GET:/templates/permissions
     * @secure
     */
    templatePermissions: (params: RequestParams = {}) =>
      this.request<TemplatePermissionResponse, any>({
        path: `/templates/permissions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a single template by id.
     *
     * @tags Templates
     * @name GetTemplate
     * @request GET:/templates/{id}
     * @secure
     */
    getTemplate: (id: string, params: RequestParams = {}) =>
      this.request<TemplateResponse, any>({
        path: `/templates/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a template by id.
     *
     * @tags Templates
     * @name DeleteTemplate
     * @request DELETE:/templates/{id}
     * @secure
     */
    deleteTemplate: (id: string, params: RequestParams = {}) =>
      this.request<TemplateDeleteResponse, any>({
        path: `/templates/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a template as a public agent definition suitable for the teammate builder.
     *
     * @tags Templates
     * @name GetTemplateAgent
     * @request GET:/templates/{id}/agent
     * @secure
     */
    getTemplateAgent: (id: string, params: RequestParams = {}) =>
      this.request<Agent, any>({
        path: `/templates/${id}/agent`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  teams = {
    /**
     * @description Create a new team
     *
     * @tags Teams
     * @name CreateTeam
     * @request POST:/teams
     * @secure
     */
    createTeam: (data: CreateTeamRequest, params: RequestParams = {}) =>
      this.request<TeamResponse, any>({
        path: `/teams`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List teams with optional filtering and pagination
     *
     * @tags Teams
     * @name ListTeams
     * @request GET:/teams
     * @secure
     */
    listTeams: (
      query?: {
        /** @format double */
        pageSize?: number;
        /** @format double */
        pageNumber?: number;
        orderBy?: string;
        orderDirection?: "ASC" | "DESC";
        sort?: string;
        searchTerm?: string;
        includeOtherUsersTeams?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TeamListResponseApi, any>({
        path: `/teams`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing team
     *
     * @tags Teams
     * @name UpdateTeam
     * @request PUT:/teams/{teamId}
     * @secure
     */
    updateTeam: (
      teamId: string,
      data: UpdateTeamRequest,
      params: RequestParams = {},
    ) =>
      this.request<TeamResponse, any>({
        path: `/teams/${teamId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a team by ID
     *
     * @tags Teams
     * @name GetTeam
     * @request GET:/teams/{teamId}
     * @secure
     */
    getTeam: (teamId: string, params: RequestParams = {}) =>
      this.request<TeamResponse, any>({
        path: `/teams/${teamId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a team by ID
     *
     * @tags Teams
     * @name DeleteTeam
     * @request DELETE:/teams/{teamId}
     * @secure
     */
    deleteTeam: (teamId: string, params: RequestParams = {}) =>
      this.request<DeleteTeamResponse, any>({
        path: `/teams/${teamId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Teams
     * @name RunTeam
     * @request POST:/teams/{teamId}/run
     * @secure
     */
    runTeam: (
      teamId: string,
      data: RunTeamRequest,
      params: RequestParams = {},
    ) =>
      this.request<TeamRunResponse, any>({
        path: `/teams/${teamId}/run`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Teams
     * @name RerunTeamFromNode
     * @request POST:/teams/{teamId}/runs/{runId}/rerun
     * @secure
     */
    rerunTeamFromNode: (
      teamId: string,
      runId: string,
      data: RerunTeamFromNodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<TeamRunResponse, any>({
        path: `/teams/${teamId}/runs/${runId}/rerun`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Duplicate a team by ID
     *
     * @tags Teams
     * @name DuplicateTeam
     * @request POST:/teams/{teamId}/duplicate
     * @secure
     */
    duplicateTeam: (teamId: string, params: RequestParams = {}) =>
      this.request<TeamResponse, any>({
        path: `/teams/${teamId}/duplicate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Share a team with another user by email
     *
     * @tags Teams
     * @name ShareTeam
     * @request POST:/teams/{teamId}/share
     * @secure
     */
    shareTeam: (
      teamId: string,
      data: ShareTeamRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/teams/${teamId}/share`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Unshare a team with a user by email
     *
     * @tags Teams
     * @name UnshareTeam
     * @request POST:/teams/{teamId}/unshare
     * @secure
     */
    unshareTeam: (
      teamId: string,
      data: ShareTeamRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/teams/${teamId}/unshare`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the organization groups a team has been shared with
     *
     * @tags Teams
     * @name GetSharedGroups
     * @request GET:/teams/{teamId}/shared-groups
     * @secure
     */
    getSharedGroups: (teamId: string, params: RequestParams = {}) =>
      this.request<TeamGroupShareResponse[], any>({
        path: `/teams/${teamId}/shared-groups`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get team groups
     *
     * @tags Teams
     * @name GetTeamGroups
     * @request GET:/teams/{teamId}/groups
     * @secure
     */
    getTeamGroups: (teamId: string, params: RequestParams = {}) =>
      this.request<GroupResponse[], any>({
        path: `/teams/${teamId}/groups`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a team group
     *
     * @tags Teams
     * @name CreateTeamGroup
     * @request POST:/teams/{teamId}/groups
     * @secure
     */
    createTeamGroup: (
      teamId: string,
      data: CreateTeamGroupRequest,
      params: RequestParams = {},
    ) =>
      this.request<TeamGroupResponse, any>({
        path: `/teams/${teamId}/groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get team run history
     *
     * @tags Teams
     * @name ListTeamRuns
     * @request GET:/teams/{teamId}/runs
     * @secure
     */
    listTeamRuns: (
      teamId: string,
      query?: {
        /** @format double */
        pageSize?: number;
        /** @format double */
        pageNumber?: number;
        orderBy?:
          | "startedAt"
          | "completedAt"
          | "createdAt"
          | "duration"
          | "status";
        orderDirection?: "ASC" | "DESC";
        status?: "all" | "complete" | "processing" | "waiting" | "error";
      },
      params: RequestParams = {},
    ) =>
      this.request<TeamRunsResponse, any>({
        path: `/teams/${teamId}/runs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get specific team run details
     *
     * @tags Teams
     * @name GetTeamRunLatestId
     * @request GET:/teams/{teamId}/runs/latest
     * @secure
     */
    getTeamRunLatestId: (teamId: string, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/teams/${teamId}/runs/latest`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get specific team run details
     *
     * @tags Teams
     * @name GetTeamRun
     * @request GET:/teams/{teamId}/runs/{runId}
     * @secure
     */
    getTeamRun: (teamId: string, runId: string, params: RequestParams = {}) =>
      this.request<TeamRunResponse, any>({
        path: `/teams/${teamId}/runs/${runId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Teams
     * @name UpdateTeamRunStepOutput
     * @request PUT:/teams/{teamId}/runs/{runId}/steps/{stepId}/output
     * @secure
     */
    updateTeamRunStepOutput: (
      teamId: string,
      runId: string,
      stepId: string,
      data: UpdateTeamRunStepOutputRequest,
      params: RequestParams = {},
    ) =>
      this.request<TeamRunStepResponse, any>({
        path: `/teams/${teamId}/runs/${runId}/steps/${stepId}/output`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Teams
     * @name ApproveTeamRunStep
     * @request POST:/teams/{teamId}/runs/{runId}/steps/{stepId}/approve
     * @secure
     */
    approveTeamRunStep: (
      teamId: string,
      runId: string,
      stepId: string,
      params: RequestParams = {},
    ) =>
      this.request<TeamRunStepResponse, string | void>({
        path: `/teams/${teamId}/runs/${runId}/steps/${stepId}/approve`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Subscribe to real-time events for a team run via Server-Sent Events (SSE). This endpoint establishes a persistent connection that streams events as they occur: - `connected` - Initial confirmation when subscription is established - `run:state` - Current state of the TeamRun (sent immediately after connected) - `step:started` - When a new TeamRunStep begins execution - `step:completed` - When a TeamRunStep completes successfully - `step:error` - When a TeamRunStep fails - `run:completed` - When the entire TeamRun completes - `run:error` - When the entire TeamRun fails - `heartbeat` - Periodic keepalive (every 30s)
     *
     * @tags Teams
     * @name SubscribeToRunEvents
     * @request GET:/teams/{teamId}/runs/{runId}/events
     * @secure
     */
    subscribeToRunEvents: (
      teamId: string,
      runId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/teams/${teamId}/runs/${runId}/events`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  sessions = {
    /**
     * No description
     *
     * @tags Sessions
     * @name ListSessions
     * @request GET:/sessions
     * @secure
     */
    listSessions: (
      query?: {
        chatflowId?: string;
        includeOtherUsers?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SessionResponse[], any>({
        path: `/sessions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sessions
     * @name CreateSession
     * @request POST:/sessions
     * @secure
     */
    createSession: (data: CreateSessionRequest, params: RequestParams = {}) =>
      this.request<SessionResponse, any>({
        path: `/sessions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sessions
     * @name UpdateSession
     * @request PUT:/sessions/{sessionId}
     * @secure
     */
    updateSession: (
      sessionId: string,
      data: UpdateSessionRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/sessions/${sessionId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sessions
     * @name DeleteSession
     * @request DELETE:/sessions/{sessionId}
     * @secure
     */
    deleteSession: (sessionId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/sessions/${sessionId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  secrets = {
    /**
     * No description
     *
     * @tags Secrets
     * @name ListSecrets
     * @request GET:/secrets
     * @secure
     */
    listSecrets: (params: RequestParams = {}) =>
      this.request<SecretResponse[], any>({
        path: `/secrets`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Secrets
     * @name CreateSecret
     * @request POST:/secrets
     * @secure
     */
    createSecret: (data: CreateSecretRequest, params: RequestParams = {}) =>
      this.request<SecretResponse, any>({
        path: `/secrets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Secrets
     * @name GetSecret
     * @request GET:/secrets/{id}
     * @secure
     */
    getSecret: (id: string, params: RequestParams = {}) =>
      this.request<SecretResponse, any>({
        path: `/secrets/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Secrets
     * @name PatchSecret
     * @request PATCH:/secrets/{id}
     * @secure
     */
    patchSecret: (
      id: string,
      data: PatchSecretRequest,
      params: RequestParams = {},
    ) =>
      this.request<SecretResponse, any>({
        path: `/secrets/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Secrets
     * @name DeleteSecret
     * @request DELETE:/secrets/{id}
     * @secure
     */
    deleteSecret: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/secrets/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  revisions = {
    /**
     * @description The changed paths between two revisions, with both redacted projections in a stable key order.
     *
     * @tags Revisions
     * @name DiffRevisions
     * @request GET:/revisions/{type}/{id}/diff
     * @secure
     */
    diffRevisions: (
      type: RevisionHistoryType,
      id: string,
      query: {
        /**
         * The older revision number.
         * @format double
         */
        from: number;
        /**
         * The newer revision number.
         * @format double
         */
        to: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionDiffResponse, any>({
        path: `/revisions/${type}/${id}/diff`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The resource's audit events (shares, integrations, schedules, Team run edits), newest first, with full details including step output text.
     *
     * @tags Revisions
     * @name ListRevisionEvents
     * @request GET:/revisions/{type}/{id}/events
     * @secure
     */
    listRevisionEvents: (
      type: RevisionHistoryType,
      id: string,
      query?: {
        /** The `nextCursor` of the previous page. */
        cursor?: string;
        /**
         * Page size (default 50, at most 200).
         * @format double
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionEventsResponse, any>({
        path: `/revisions/${type}/${id}/events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description References saved in the resource's latest revision (Skills, Sub-Teammates, User Tools, Team member Teammates) whose target has been edited since. References the caller cannot read are omitted.
     *
     * @tags Revisions
     * @name ListUpstreamChanges
     * @request GET:/revisions/{type}/{id}/upstream-changes
     * @secure
     */
    listUpstreamChanges: (
      type: RevisionHistoryType,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<RevisionUpstreamChangesResponse, any>({
        path: `/revisions/${type}/${id}/upstream-changes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description A metadata page of the resource's revisions, newest first.
     *
     * @tags Revisions
     * @name ListRevisions
     * @request GET:/revisions/{type}/{id}
     * @secure
     */
    listRevisions: (
      type: RevisionHistoryType,
      id: string,
      query?: {
        /**
         * The `nextCursor` of the previous page (a revision number).
         * @format double
         */
        cursor?: number;
        /**
         * Page size (default 50, at most 200).
         * @format double
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionListResponse, any>({
        path: `/revisions/${type}/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description One revision with its redacted projection, secret set/unset markers, refs and schema version.
     *
     * @tags Revisions
     * @name GetRevision
     * @request GET:/revisions/{type}/{id}/{revisionNo}
     * @secure
     */
    getRevision: (
      type: RevisionHistoryType,
      id: string,
      revisionNo: number,
      params: RequestParams = {},
    ) =>
      this.request<RevisionDetailResponse, any>({
        path: `/revisions/${type}/${id}/${revisionNo}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description An editor draft of one revision, to load as an unsaved form and persist with the normal Save. Redacted secrets are refilled from the live Teammate tool node or User Tool action where it still exists and holds a value; the rest are listed in `missingSecrets`. Retired tools are dropped and listed in `unavailableTools`. Older pinned User Tool versions are listed in `staleToolVersions` and, with `keepCurrentToolVersions=true`, rewritten to each lineage's latest version. Deleted or inaccessible references are listed in `brokenRefs`.
     *
     * @tags Revisions
     * @name GetRestoreDraft
     * @request GET:/revisions/{type}/{id}/{revisionNo}/restore-draft
     * @secure
     */
    getRestoreDraft: (
      type: RevisionHistoryType,
      id: string,
      revisionNo: number,
      query?: {
        /** Rewrite pinned User Tool versions to each lineage's latest. */
        keepCurrentToolVersions?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionRestoreDraftResponse, any>({
        path: `/revisions/${type}/${id}/${revisionNo}/restore-draft`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  resourceBundles = {
    /**
     * @description Export resources and their full reference closure as a zip bundle. There is no preflight check: walking the closure to decide exportability costs the same as exporting, so this fails with 403 naming the specific resources the user cannot view.
     *
     * @tags Resource Bundles
     * @name ExportBundle
     * @request POST:/resource-bundles/export
     * @secure
     */
    exportBundle: (data: ExportBundleRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/resource-bundles/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Import a bundle zip. All-or-nothing: nothing is created unless everything succeeds. Resources already present here (matched by primary key) and viewable by this user are reused rather than duplicated, unless `reuseExisting` is sent as `false`.
     *
     * @tags Resource Bundles
     * @name ImportBundle
     * @request POST:/resource-bundles/import
     * @secure
     */
    importBundle: (params: RequestParams = {}) =>
      this.request<ImportBundleResponse, any>({
        path: `/resource-bundles/import`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  permissions = {
    /**
     * No description
     *
     * @tags Permissions
     * @name InvalidateUserPermissions
     * @request POST:/permissions/invalidate
     * @secure
     */
    invalidateUserPermissions: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/permissions/invalidate`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name InvalidateUserPermissionsById
     * @request POST:/permissions/invalidate-user
     * @secure
     */
    invalidateUserPermissionsById: (
      data: InvalidateUserPermissionsRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/permissions/invalidate-user`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  organizationAuditLog = {
    /**
     * @description The active organization's audit log: Teammate, Team, Skill and User Tool revisions interleaved with non-config audit events (shares, integrations, API keys, schedules, Team run edits), newest first. Includes the history of deleted resources. Scoped to rows whose resource belongs to the organization, plus rows of org-less resources written by a member acting in it. Requires the `view organization_audit_log` permission.
     *
     * @tags Organization Audit Log
     * @name GetOrganizationAuditLog
     * @request GET:/organization/audit-log
     * @secure
     */
    getOrganizationAuditLog: (
      query?: {
        /** The `nextCursor` of the previous page. */
        cursor?: string;
        /**
         * Page size (default 50, at most 100).
         * @format double
         */
        limit?: number;
        /** Only this resource type. */
        resourceType?: AuditLogResourceType;
        /** Only this resource (the lineage parentId for a User Tool). */
        resourceId?: string;
        /** Only entries written by this user. */
        actorUserId?: string;
        /** Exact type, e.g. `share.user.granted`, or `revision.<operation>` such as `revision.update`. */
        eventType?: string;
        /** Inclusive lower bound on `createdAt` (ISO 8601). */
        from?: string;
        /** Exclusive upper bound on `createdAt` (ISO 8601). */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuditLogResponse, any>({
        path: `/organization/audit-log`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  nodes = {
    /**
     * @description List the component nodes available to the authenticated user, filtered by permission.
     *
     * @tags Nodes
     * @name GetNodes
     * @request GET:/nodes
     * @secure
     */
    getNodes: (params: RequestParams = {}) =>
      this.request<ComponentNodeResponse[], any>({
        path: `/nodes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a single component node by name.
     *
     * @tags Nodes
     * @name GetNode
     * @request GET:/nodes/{name}
     * @secure
     */
    getNode: (name: string, params: RequestParams = {}) =>
      this.request<ComponentNodeResponse, any>({
        path: `/nodes/${name}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Load the current options for a node input flagged `supportsDynamicRefresh`, based on the calling user's authorization and the node's other input values.
     *
     * @tags Nodes
     * @name GetNodeInputOptions
     * @request POST:/nodes/{name}/input-options/{inputName}
     * @secure
     */
    getNodeInputOptions: (
      name: string,
      inputName: string,
      data: NodeInputOptionsRequest,
      params: RequestParams = {},
    ) =>
      this.request<NodeOptionResponse[], any>({
        path: `/nodes/${name}/input-options/${inputName}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the icon for a component node by name. Public (no authentication) so it can be referenced directly from `<img>` tags. Falls back to the generic tool icon for unknown names (user tools).
     *
     * @tags Nodes
     * @name GetNodeIcon
     * @request GET:/nodes/{name}/icon
     */
    getNodeIcon: (name: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/nodes/${name}/icon`,
        method: "GET",
        ...params,
      }),
  };
  modelEvaluator = {
    /**
     * @description Run a tool-use evaluation test for a given model against a single tool node.
     *
     * @tags Model Evaluator
     * @name RunTest
     * @request POST:/model-evaluator
     * @secure
     */
    runTest: (data: RunModelEvaluatorRequest, params: RequestParams = {}) =>
      this.request<ModelEvaluatorResult, any>({
        path: `/model-evaluator`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  languageModels = {
    /**
     * @description Get accepted MIME types for a specific model or all possible types
     *
     * @tags LanguageModels
     * @name GetAcceptedFileTypesByModel
     * @request GET:/models/accepted-types
     * @secure
     */
    getAcceptedFileTypesByModel: (
      query?: {
        /** Optional model ID to get specific capabilities for */
        model?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ModelAcceptedMimeTypes, any>({
        path: `/models/accepted-types`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List language models available to the authenticated user. Results are filtered by the user's LLM provider permissions and sorted by provider type and label.
     *
     * @tags Language Models
     * @name GetLanguageModels
     * @request GET:/language-models
     * @secure
     */
    getLanguageModels: (
      query?: {
        /** Optional node name to scope the available models to a specific node. */
        node?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LanguageModelResponse[], any>({
        path: `/language-models`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a single language model by id.
     *
     * @tags Language Models
     * @name GetLanguageModelById
     * @request GET:/language-models/{id}
     * @secure
     */
    getLanguageModelById: (
      id: string,
      query?: {
        /** Optional node name to scope the lookup to a specific node. */
        node?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LanguageModelResponse, any>({
        path: `/language-models/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  chatFiles = {
    /**
     * No description
     *
     * @tags ChatFiles
     * @name DeleteChatFile
     * @request DELETE:/chatflows/{chatflowId}/files/{chatFileId}
     * @secure
     */
    deleteChatFile: (
      chatflowId: string,
      chatFileId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/chatflows/${chatflowId}/files/${chatFileId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Get accepted MIME types for a specific chatflow
     *
     * @tags ChatFiles
     * @name GetAcceptedFileTypesByChatflow
     * @request GET:/chatflows/{chatflowId}/files/accepted-types
     * @secure
     */
    getAcceptedFileTypesByChatflow: (
      chatflowId: string,
      params: RequestParams = {},
    ) =>
      this.request<ModelAcceptedMimeTypes, any>({
        path: `/chatflows/${chatflowId}/files/accepted-types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Stream a chat file to the client. Authentication is via the file-access cookie (set by torqcloud-api); authorization checks that the user can access the chatflow.
     *
     * @tags ChatFiles
     * @name StreamFile
     * @request GET:/chatflows/{chatflowId}/sessions/{sessionId}/files/{chatFileId}/stream
     */
    streamFile: (
      chatflowId: string,
      sessionId: string,
      chatFileId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/chatflows/${chatflowId}/sessions/${sessionId}/files/${chatFileId}/stream`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatFiles
     * @name ListChatFiles
     * @request GET:/chatflows/{chatflowId}/files
     * @secure
     */
    listChatFiles: (
      chatflowId: string,
      query?: {
        pending?: boolean;
        sessionId?: string;
        types?: ChatFileTypeParam[];
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/chatflows/${chatflowId}/files`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatFiles
     * @name CreateChatFiles
     * @request POST:/chatflows/{chatflowId}/files
     * @secure
     */
    createChatFiles: (
      chatflowId: string,
      data: {
        files: File[];
      },
      query?: {
        sessionId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CreateChatFilesResponse, any>({
        path: `/chatflows/${chatflowId}/files`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  chatflows = {
    /**
     * @description Lists the distinct tags on the Teammates the caller can see, for tag pickers and filters (WF-2820). Admins who can manage other users' Teammates see every tag in their organization.
     *
     * @tags Chatflows
     * @name GetChatflowTags
     * @request GET:/chatflows/tags
     * @secure
     */
    getChatflowTags: (
      query?: {
        /** Optional case-insensitive substring a tag must contain. */
        search?: string;
        /**
         * @format double
         * @default 50
         */
        pageSize?: number;
        /**
         * @format double
         * @default 1
         */
        pageNumber?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatflowTagListResponse, any>({
        path: `/chatflows/tags`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Promote a playground chatflow to a standard teammate so it appears in the My Teammates list.
     *
     * @tags Chatflows
     * @name ConvertToTeammate
     * @request POST:/chatflows/{id}/convert-to-teammate
     * @secure
     */
    convertToTeammate: (id: string, params: RequestParams = {}) =>
      this.request<ChatflowResponse, any>({
        path: `/chatflows/${id}/convert-to-teammate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name IsChatflowStreamable
     * @request GET:/chatflows/{id}/streamable
     * @secure
     */
    isChatflowStreamable: (id: string, params: RequestParams = {}) =>
      this.request<ChatflowStreamableResponse, any>({
        path: `/chatflows/${id}/streamable`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name GetAssociatedTeams
     * @request GET:/chatflows/{id}/associated-teams
     * @secure
     */
    getAssociatedTeams: (id: string, params: RequestParams = {}) =>
      this.request<AssociatedTeamsResponse, any>({
        path: `/chatflows/${id}/associated-teams`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The pieces of this Teammate the caller cannot access. A Teammate is shareable without its Skills and Tools, so a recipient can be looking at a canvas whose parts will silently not be there when they chat. The prediction path already drops those parts (WF-2691, and WF-2727 for Skills); this reports them so the builder and the chat settings panel can name them and warn instead of showing a bare "Invalid" badge. Only names are returned, never bodies or configuration, and only to a caller who can already view the Teammate that references them. (WF-2727)
     *
     * @tags Chatflows
     * @name GetInaccessibleResources
     * @request GET:/chatflows/{id}/inaccessible-resources
     * @secure
     */
    getInaccessibleResources: (id: string, params: RequestParams = {}) =>
      this.request<InaccessibleResourcesResponse, any>({
        path: `/chatflows/${id}/inaccessible-resources`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name ShareChatflow
     * @request POST:/chatflows/{id}/share
     * @secure
     */
    shareChatflow: (
      id: string,
      data: ShareChatflowRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShareChatflowResponse | ShareChatflowErrorResponse, any>({
        path: `/chatflows/${id}/share`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name UnshareChatflow
     * @request POST:/chatflows/{id}/unshare
     * @secure
     */
    unshareChatflow: (
      id: string,
      data: ShareChatflowRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/chatflows/${id}/unshare`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name DuplicateChatflow
     * @request POST:/chatflows/{id}/duplicate
     * @secure
     */
    duplicateChatflow: (id: string, params: RequestParams = {}) =>
      this.request<ChatflowResponse, any>({
        path: `/chatflows/${id}/duplicate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name GetSharedUsers
     * @request GET:/chatflows/{id}/users
     * @secure
     */
    getSharedUsers: (id: string, params: RequestParams = {}) =>
      this.request<ChatflowSharedUserResponse[], any>({
        path: `/chatflows/${id}/users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name GetSharedGroups
     * @request GET:/chatflows/{id}/groups
     * @secure
     */
    getSharedGroups: (id: string, params: RequestParams = {}) =>
      this.request<ChatflowSharedGroupResponse[], any>({
        path: `/chatflows/${id}/groups`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name StreamSessionEvents
     * @request GET:/chatflows/{id}/sessions/{sessionId}/events
     * @secure
     */
    streamSessionEvents: (
      id: string,
      sessionId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/chatflows/${id}/sessions/${sessionId}/events`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name GetChatflowMessages
     * @request GET:/chatflows/{id}/messages
     * @secure
     */
    getChatflowMessages: (id: string, params: RequestParams = {}) =>
      this.request<ChatMessageResponse[], any>({
        path: `/chatflows/${id}/messages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name CreateChatflowMessage
     * @request POST:/chatflows/{id}/messages
     * @secure
     */
    createChatflowMessage: (
      id: string,
      data: CreateChatflowMessageRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChatMessageResponse, any>({
        path: `/chatflows/${id}/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name DeleteChatflowMessages
     * @request DELETE:/chatflows/{id}/messages
     * @secure
     */
    deleteChatflowMessages: (id: string, params: RequestParams = {}) =>
      this.request<DeleteMessagesResponse, any>({
        path: `/chatflows/${id}/messages`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name GetChatflowMessagesForSession
     * @request GET:/chatflows/{id}/sessions/{sessionId}/messages
     * @secure
     */
    getChatflowMessagesForSession: (
      id: string,
      sessionId: string,
      params: RequestParams = {},
    ) =>
      this.request<ChatMessageResponse[], any>({
        path: `/chatflows/${id}/sessions/${sessionId}/messages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name CreateChatflowMessageForSession
     * @request POST:/chatflows/{id}/sessions/{sessionId}/messages
     * @secure
     */
    createChatflowMessageForSession: (
      id: string,
      sessionId: string,
      data: CreateChatflowMessageRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChatMessageResponse, any>({
        path: `/chatflows/${id}/sessions/${sessionId}/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name DeleteChatflowMessagesForSession
     * @request DELETE:/chatflows/{id}/sessions/{sessionId}/messages
     * @secure
     */
    deleteChatflowMessagesForSession: (
      id: string,
      sessionId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeleteMessagesResponse, any>({
        path: `/chatflows/${id}/sessions/${sessionId}/messages`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name ApproveToolCall
     * @request POST:/chatflows/{id}/sessions/{sessionId}/messages/{messageId}/approve
     * @secure
     */
    approveToolCall: (
      id: string,
      sessionId: string,
      messageId: string,
      data: ApproveToolCallRequest,
      params: RequestParams = {},
    ) =>
      this.request<ToolCallResolutionResponse, any>({
        path: `/chatflows/${id}/sessions/${sessionId}/messages/${messageId}/approve`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name RejectToolCall
     * @request POST:/chatflows/{id}/sessions/{sessionId}/messages/{messageId}/reject
     * @secure
     */
    rejectToolCall: (
      id: string,
      sessionId: string,
      messageId: string,
      data: RejectToolCallRequest,
      params: RequestParams = {},
    ) =>
      this.request<ToolCallResolutionResponse, any>({
        path: `/chatflows/${id}/sessions/${sessionId}/messages/${messageId}/reject`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name CancelSubTeammateExecution
     * @request POST:/chatflows/{id}/sessions/{sessionId}/messages/{messageId}/cancel-sub-teammate
     * @secure
     */
    cancelSubTeammateExecution: (
      id: string,
      sessionId: string,
      messageId: string,
      data: CancelSubTeammateRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/chatflows/${id}/sessions/${sessionId}/messages/${messageId}/cancel-sub-teammate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name AcceptSubTeammateResult
     * @request POST:/chatflows/{id}/sessions/{sessionId}/messages/{messageId}/accept-sub-teammate
     * @secure
     */
    acceptSubTeammateResult: (
      id: string,
      sessionId: string,
      messageId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/chatflows/${id}/sessions/${sessionId}/messages/${messageId}/accept-sub-teammate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name SubmitSubTeammateFollowUp
     * @request POST:/chatflows/{id}/sessions/{sessionId}/messages/{messageId}/sub-teammate-followup
     * @secure
     */
    submitSubTeammateFollowUp: (
      id: string,
      sessionId: string,
      messageId: string,
      data: SubTeammateFollowUpRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/chatflows/${id}/sessions/${sessionId}/messages/${messageId}/sub-teammate-followup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name GetChatMessageFeedback
     * @request GET:/chatflows/{id}/sessions/{sessionId}/messages/{messageId}/feedback
     * @secure
     */
    getChatMessageFeedback: (
      id: string,
      sessionId: string,
      messageId: string,
      params: RequestParams = {},
    ) =>
      this.request<ChatMessageFeedbackResponse, any>({
        path: `/chatflows/${id}/sessions/${sessionId}/messages/${messageId}/feedback`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name SaveChatMessageFeedback
     * @request POST:/chatflows/{id}/sessions/{sessionId}/messages/{messageId}/feedback
     * @secure
     */
    saveChatMessageFeedback: (
      id: string,
      sessionId: string,
      messageId: string,
      data: ChatMessageFeedbackRequest,
      params: RequestParams = {},
    ) =>
      this.request<SaveFeedbackResponse, any>({
        path: `/chatflows/${id}/sessions/${sessionId}/messages/${messageId}/feedback`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name RunInternalPrediction
     * @request POST:/chatflows/{id}/internal-prediction
     * @secure
     */
    runInternalPrediction: (
      id: string,
      data: InternalPredictionInput,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/chatflows/${id}/internal-prediction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name RunPrediction
     * @request POST:/chatflows/{id}/prediction
     */
    runPrediction: (
      id: string,
      data: PublicPredictionInput,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/chatflows/${id}/prediction`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name BotFramework
     * @request POST:/chatflows/botframework
     */
    botFramework: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/chatflows/botframework`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name BotFrameworkForOrganization
     * @request POST:/chatflows/botframework/{routingToken}
     */
    botFrameworkForOrganization: (
      routingToken: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/chatflows/botframework/${routingToken}`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Get the feedback for a chat message by its id (used by the message-feedback widget).
     *
     * @tags Chatflows
     * @name GetChatMessageFeedbackByMessageId
     * @request GET:/messages/{messageId}/feedback
     * @secure
     */
    getChatMessageFeedbackByMessageId: (
      messageId: string,
      params: RequestParams = {},
    ) =>
      this.request<ChatMessageFeedbackResponse, any>({
        path: `/messages/${messageId}/feedback`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Save feedback for a chat message by its id.
     *
     * @tags Chatflows
     * @name SaveChatMessageFeedbackByMessageId
     * @request POST:/messages/{messageId}/feedback
     * @secure
     */
    saveChatMessageFeedbackByMessageId: (
      messageId: string,
      data: ChatMessageFeedbackRequest,
      params: RequestParams = {},
    ) =>
      this.request<SaveFeedbackResponse, any>({
        path: `/messages/${messageId}/feedback`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name GetChatflows
     * @request GET:/chatflows
     * @secure
     */
    getChatflows: (
      query?: {
        filter?: string;
        show?: "owned" | "shared" | "accessible";
        sort?: string;
        orderBy?: ChatflowSortField;
        orderDirection?: ChatflowOrderDirection;
        /**
         * @format double
         * @default 20
         */
        pageSize?: number;
        /**
         * @format double
         * @default 1
         */
        pageNumber?: number;
        chatFlowType?: ChatflowType;
        /**
         * Matches only Teammates carrying every one of these tags (repeat the parameter for several).
         * Send it once with an empty value (`tags=`) to match only untagged Teammates; omit it to apply
         * no tag filter.
         */
        tags?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatflowListResponse, any>({
        path: `/chatflows`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name CreateChatflow
     * @request POST:/chatflows
     * @secure
     */
    createChatflow: (data: CreateChatflowRequest, params: RequestParams = {}) =>
      this.request<ChatflowResponse, any>({
        path: `/chatflows`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name GetChatflow
     * @request GET:/chatflows/{id}
     * @secure
     */
    getChatflow: (id: string, params: RequestParams = {}) =>
      this.request<ChatflowResponse, any>({
        path: `/chatflows/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name DeleteChatflow
     * @request DELETE:/chatflows/{id}
     * @secure
     */
    deleteChatflow: (id: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/chatflows/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name UpdateChatflow
     * @request PUT:/chatflows/{id}
     * @secure
     */
    updateChatflow: (
      id: string,
      data: UpdateChatflowRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChatflowResponse, any>({
        path: `/chatflows/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name RunQueuePrediction
     * @request POST:/chatflows/{id}/queue-prediction
     * @secure
     */
    runQueuePrediction: (
      id: string,
      data: {
        /** JSON-encoded complete queued-message payload */
        message: string;
        files?: File[];
      },
      query?: {
        sessionId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<QueuedPredictionResponse, any>({
        path: `/chatflows/${id}/queue-prediction`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflows
     * @name RunLegacyQueuePrediction
     * @request POST:/chatflows/{id}/sessions/{sessionId}/prediction
     * @secure
     */
    runLegacyQueuePrediction: (
      id: string,
      sessionId: string,
      data: {
        /** JSON-encoded complete queued-message payload */
        message: string;
        files?: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<QueuedPredictionResponse, any>({
        path: `/chatflows/${id}/sessions/${sessionId}/prediction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  memories = {
    /**
     * No description
     *
     * @tags Memories
     * @name ListMemories
     * @request GET:/memories
     * @secure
     */
    listMemories: (
      query?: {
        /** @format double */
        pageSize?: number;
        /** @format double */
        pageNumber?: number;
        query?: string;
        /** @format double */
        threshold?: number;
        teammateId?: string;
        agentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MemoryListResponse, any>({
        path: `/memories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memories
     * @name GetMemoryGraph
     * @request GET:/memories/graph
     * @secure
     */
    getMemoryGraph: (
      query?: {
        /** @format double */
        limit?: number;
        teammateId?: string;
        agentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MemoryGraphResponse, any>({
        path: `/memories/graph`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memories
     * @name UpdateMemory
     * @request PUT:/memories/{memoryId}
     * @secure
     */
    updateMemory: (
      memoryId: string,
      data: UpdateMemoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateMemoryResponse, any>({
        path: `/memories/${memoryId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memories
     * @name DeleteMemory
     * @request DELETE:/memories/{memoryId}
     * @secure
     */
    deleteMemory: (memoryId: string, params: RequestParams = {}) =>
      this.request<DeleteMemoryResponse, any>({
        path: `/memories/${memoryId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  knowledgeBaseWebsites = {
    /**
     * @description GET /api/v1/knowledge-base-websites/crawl-status?chatflowId=<id> Returns the latest crawl state for every website linked to the given Teammate.
     *
     * @tags Knowledge Base Websites
     * @name GetCrawlStatus
     * @request GET:/knowledge-base-websites/crawl-status
     * @secure
     */
    getCrawlStatus: (
      query?: {
        chatflowId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CrawlStatusResponse, any>({
        path: `/knowledge-base-websites/crawl-status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  integrationConfigurations = {
    /**
     * No description
     *
     * @tags Integration Configurations
     * @name ListConfigurations
     * @request GET:/integration-configurations
     * @secure
     */
    listConfigurations: (params: RequestParams = {}) =>
      this.request<IntegrationConfigurationResponse[], any>({
        path: `/integration-configurations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Configurations
     * @name CreateConfiguration
     * @request POST:/integration-configurations
     * @secure
     */
    createConfiguration: (
      data: CreateIntegrationConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationConfigurationResponse, any>({
        path: `/integration-configurations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Configurations
     * @name GetConfiguration
     * @request GET:/integration-configurations/{kind}
     * @secure
     */
    getConfiguration: (kind: IntegrationKind, params: RequestParams = {}) =>
      this.request<IntegrationConfigurationResponse, any>({
        path: `/integration-configurations/${kind}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the active organization's configuration for a kind. IMPORTANT This is a true PATCH handler, in that it only expects changes, not the full creation payload. It's important to do it like this because we don't send the full clientSecret to the ui.
     *
     * @tags Integration Configurations
     * @name UpdateConfiguration
     * @request PATCH:/integration-configurations/{kind}
     * @secure
     */
    updateConfiguration: (
      kind: IntegrationKind,
      data: PatchIntegrationConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationConfigurationResponse, any>({
        path: `/integration-configurations/${kind}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Configurations
     * @name DeleteConfiguration
     * @request DELETE:/integration-configurations/{kind}
     * @secure
     */
    deleteConfiguration: (kind: IntegrationKind, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/integration-configurations/${kind}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  integrationAuthorizations = {
    /**
     * No description
     *
     * @tags Integration Authorizations
     * @name ListAuthorizations
     * @request GET:/integration-authorizations
     * @secure
     */
    listAuthorizations: (params: RequestParams = {}) =>
      this.request<IntegrationAuthorizationResponse[], any>({
        path: `/integration-authorizations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Complete the authorization: exchange the code returned to the redirect URI for tokens (server-side, using the effective app's client secret) and persist them for the caller. Doubles as re-authorization — an existing authorization is replaced in place.
     *
     * @tags Integration Authorizations
     * @name CompleteAuthorization
     * @request POST:/integration-authorizations
     * @secure
     */
    completeAuthorization: (
      data: CompleteAuthorizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationAuthorizationResponse, any>({
        path: `/integration-authorizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Authorizations
     * @name GetAuthorization
     * @request GET:/integration-authorizations/{kind}
     * @secure
     */
    getAuthorization: (kind: IntegrationKind, params: RequestParams = {}) =>
      this.request<IntegrationAuthorizationResponse, any>({
        path: `/integration-authorizations/${kind}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Authorizations
     * @name DeleteAuthorization
     * @request DELETE:/integration-authorizations/{kind}
     * @secure
     */
    deleteAuthorization: (kind: IntegrationKind, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/integration-authorizations/${kind}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Build the Microsoft consent URL the authorization popup opens. Resolves the effective app (the organization's IntegrationConfiguration, else the global fallback) so the user authorizes against the right app. `state` is a CSRF nonce the caller stores and verifies on its callback (D2: SPA-hosted callback + bearer — the exchange is completed via POST).
     *
     * @tags Integration Authorizations
     * @name GetAuthorizationUrl
     * @request GET:/integration-authorizations/{kind}/authorization-url
     * @secure
     */
    getAuthorizationUrl: (kind: IntegrationKind, params: RequestParams = {}) =>
      this.request<AuthorizationUrlResponse, any>({
        path: `/integration-authorizations/${kind}/authorization-url`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  documentCollections = {
    /**
     * @description List all document collections.
     *
     * @tags Document Collections
     * @name GetDocumentCollections
     * @request GET:/document-collections
     * @secure
     */
    getDocumentCollections: (params: RequestParams = {}) =>
      this.request<DocumentCollectionResponse[], any>({
        path: `/document-collections`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new document collection, optionally configuring vector search.
     *
     * @tags Document Collections
     * @name CreateDocumentCollection
     * @request POST:/document-collections
     * @secure
     */
    createDocumentCollection: (
      data: CreateDocumentCollectionRequest,
      params: RequestParams = {},
    ) =>
      this.request<DocumentCollectionResponse, any>({
        path: `/document-collections`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Legacy endpoint: returns the document collection (the document id is currently ignored, matching the prior behavior).
     *
     * @tags Document Collections
     * @name GetDocumentCollectionForDocument
     * @request GET:/document-collections/{id}/document/{docId}
     * @secure
     */
    getDocumentCollectionForDocument: (
      id: string,
      docId: string,
      params: RequestParams = {},
    ) =>
      this.request<DocumentCollectionResponse, any>({
        path: `/document-collections/${id}/document/${docId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a single document from a collection.
     *
     * @tags Document Collections
     * @name DeleteDocument
     * @request DELETE:/document-collections/{id}/document/{docId}
     * @secure
     */
    deleteDocument: (id: string, docId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/document-collections/${id}/document/${docId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description List the documents in a collection with their extraction and indexing status (WF-2416).
     *
     * @tags Document Collections
     * @name GetDocumentsWithStatus
     * @request GET:/document-collections/{id}/documents
     * @secure
     */
    getDocumentsWithStatus: (id: string, params: RequestParams = {}) =>
      this.request<DocumentStatusResponse[], any>({
        path: `/document-collections/${id}/documents`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a single document's extraction and indexing status (WF-2416).
     *
     * @tags Document Collections
     * @name GetDocumentWithStatus
     * @request GET:/document-collections/{id}/documents/{docId}
     * @secure
     */
    getDocumentWithStatus: (
      id: string,
      docId: string,
      params: RequestParams = {},
    ) =>
      this.request<DocumentStatusResponse, any>({
        path: `/document-collections/${id}/documents/${docId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentCollections
     * @name GetExtractedText
     * @request GET:/document-collections/{id}/documents/{docId}/extracted
     * @secure
     */
    getExtractedText: (id: string, docId: string, params: RequestParams = {}) =>
      this.request<ExtractedTextResponse, any>({
        path: `/document-collections/${id}/documents/${docId}/extracted`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentCollections
     * @name UpdateExtractedText
     * @request PUT:/document-collections/{id}/documents/{docId}/extracted
     * @secure
     */
    updateExtractedText: (
      id: string,
      docId: string,
      data: UpdateExtractedTextRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateExtractedTextResponse, any>({
        path: `/document-collections/${id}/documents/${docId}/extracted`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a document collection (including its documents) by id.
     *
     * @tags Document Collections
     * @name GetDocumentCollection
     * @request GET:/document-collections/{id}
     * @secure
     */
    getDocumentCollection: (id: string, params: RequestParams = {}) =>
      this.request<DocumentCollectionResponse, any>({
        path: `/document-collections/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a document collection and its associated vectors.
     *
     * @tags Document Collections
     * @name DeleteDocumentCollection
     * @request DELETE:/document-collections/{id}
     * @secure
     */
    deleteDocumentCollection: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/document-collections/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Upload one or more documents to a collection.
     *
     * @tags Document Collections
     * @name AddDocuments
     * @request POST:/document-collections/{id}
     * @secure
     */
    addDocuments: (
      id: string,
      data: {
        files: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<UserDocumentResponse[], any>({
        path: `/document-collections/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  chatflowIntegrations = {
    /**
     * No description
     *
     * @tags Chatflow Integrations
     * @name ListIntegrations
     * @request GET:/chatflows/{id}/integrations
     * @secure
     */
    listIntegrations: (id: string, params: RequestParams = {}) =>
      this.request<ChatflowIntegrationResponse[], any>({
        path: `/chatflows/${id}/integrations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflow Integrations
     * @name CreateIntegration
     * @request POST:/chatflows/{id}/integrations/{kind}
     * @secure
     */
    createIntegration: (
      id: string,
      kind: IntegrationKind,
      params: RequestParams = {},
    ) =>
      this.request<ChatflowIntegrationResponse, any>({
        path: `/chatflows/${id}/integrations/${kind}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chatflow Integrations
     * @name DeleteIntegration
     * @request DELETE:/chatflows/{id}/integrations/{kind}
     * @secure
     */
    deleteIntegration: (
      id: string,
      kind: IntegrationKind,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/chatflows/${id}/integrations/${kind}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  apiKeys = {
    /**
     * @description List the API keys owned by the authenticated user within their active organization.
     *
     * @tags API Keys
     * @name GetApiKeys
     * @request GET:/apiKeys
     * @secure
     */
    getApiKeys: (params: RequestParams = {}) =>
      this.request<ApiKeyResponse[], any>({
        path: `/apiKeys`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new API key. The plaintext key is returned only in this response.
     *
     * @tags API Keys
     * @name CreateApiKey
     * @request POST:/apiKeys
     * @secure
     */
    createApiKey: (data: CreateApiKeyRequest, params: RequestParams = {}) =>
      this.request<CreateApiKeyResponse, any>({
        path: `/apiKeys`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Rename an API key owned by the authenticated user.
     *
     * @tags API Keys
     * @name UpdateApiKey
     * @request PUT:/apiKeys/{id}
     * @secure
     */
    updateApiKey: (
      id: string,
      data: UpdateApiKeyRequest,
      params: RequestParams = {},
    ) =>
      this.request<ApiKeyResponse, any>({
        path: `/apiKeys/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an API key owned by the authenticated user. Any fine-grained associations the key held are removed with it by the association tables' ON DELETE CASCADE.
     *
     * @tags API Keys
     * @name DeleteApiKey
     * @request DELETE:/apiKeys/{id}
     * @secure
     */
    deleteApiKey: (id: string, params: RequestParams = {}) =>
      this.request<DeleteApiKeyResponse, any>({
        path: `/apiKeys/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  userTools = {
    /**
     * No description
     *
     * @tags User Tools
     * @name ListUserTools
     * @request GET:/user-tools
     * @secure
     */
    listUserTools: (
      query?: {
        ownership?: UserToolOwnershipFilter;
        filter?: string;
        sort?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<UserToolSummary[], any>({
        path: `/user-tools`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name CreateUserTool
     * @request POST:/user-tools
     * @secure
     */
    createUserTool: (data: CreateUserToolRequest, params: RequestParams = {}) =>
      this.request<UserToolResponse, any>({
        path: `/user-tools`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name CanPublish
     * @request GET:/user-tools/can-publish
     * @secure
     */
    canPublish: (params: RequestParams = {}) =>
      this.request<
        {
          permitted: boolean;
        },
        any
      >({
        path: `/user-tools/can-publish`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name TestAction
     * @request POST:/user-tools/test-action
     * @secure
     */
    testAction: (data: TestActionInput, params: RequestParams = {}) =>
      this.request<RecordStringUnknown, any>({
        path: `/user-tools/test-action`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name ListAvailableActions
     * @request GET:/user-tools/actions
     * @secure
     */
    listAvailableActions: (params: RequestParams = {}) =>
      this.request<UserToolActionType[], any>({
        path: `/user-tools/actions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name GetUserToolActionIcon
     * @request GET:/user-tools/actions/{actionId}/icon
     * @secure
     */
    getUserToolActionIcon: (actionId: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/user-tools/actions/${actionId}/icon`,
        method: "GET",
        secure: true,
        format: "blob",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name GetLatestUserToolByParentId
     * @request GET:/user-tools/{parentId}
     * @secure
     */
    getLatestUserToolByParentId: (
      parentId: string,
      params: RequestParams = {},
    ) =>
      this.request<UserToolResponse, any>({
        path: `/user-tools/${parentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name CreateNewUserToolVersion
     * @request PATCH:/user-tools/{parentId}
     * @secure
     */
    createNewUserToolVersion: (
      parentId: string,
      data: NewUserToolVersionRequest,
      params: RequestParams = {},
    ) =>
      this.request<UserToolResponse, any>({
        path: `/user-tools/${parentId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name DeleteUserTool
     * @request DELETE:/user-tools/{parentId}
     * @secure
     */
    deleteUserTool: (parentId: string, params: RequestParams = {}) =>
      this.request<UserToolSummary, any>({
        path: `/user-tools/${parentId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name GetUserToolVersionById
     * @request GET:/user-tools/versions/{id}
     * @secure
     */
    getUserToolVersionById: (id: string, params: RequestParams = {}) =>
      this.request<UserToolResponse, any>({
        path: `/user-tools/versions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name DuplicateUserTool
     * @request POST:/user-tools/{parentId}/duplicate
     * @secure
     */
    duplicateUserTool: (parentId: string, params: RequestParams = {}) =>
      this.request<UserToolResponse, any>({
        path: `/user-tools/${parentId}/duplicate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name RenameUserTool
     * @request PATCH:/user-tools/{parentId}/rename
     * @secure
     */
    renameUserTool: (
      parentId: string,
      data: RenameUserToolRequest,
      params: RequestParams = {},
    ) =>
      this.request<UserToolResponse, any>({
        path: `/user-tools/${parentId}/rename`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name GetUserToolErrors
     * @request GET:/user-tools/{parentId}/errors
     * @secure
     */
    getUserToolErrors: (parentId: string, params: RequestParams = {}) =>
      this.request<UserToolErrorResponse[], any>({
        path: `/user-tools/${parentId}/errors`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name ShareUserTool
     * @request POST:/user-tools/{parentId}/share
     * @secure
     */
    shareUserTool: (
      parentId: string,
      data: NewUserToolShare,
      params: RequestParams = {},
    ) =>
      this.request<UserToolResponse, any>({
        path: `/user-tools/${parentId}/share`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name UnshareUserTool
     * @request POST:/user-tools/{parentId}/unshare
     * @secure
     */
    unshareUserTool: (
      parentId: string,
      data: {
        groupId?: string;
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserTool, any>({
        path: `/user-tools/${parentId}/unshare`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name GetSharedUsers
     * @request GET:/user-tools/{parentId}/shared-users
     * @secure
     */
    getSharedUsers: (parentId: string, params: RequestParams = {}) =>
      this.request<UserToolShare[], any>({
        path: `/user-tools/${parentId}/shared-users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name GetSharedGroups
     * @request GET:/user-tools/{parentId}/shared-groups
     * @secure
     */
    getSharedGroups: (parentId: string, params: RequestParams = {}) =>
      this.request<UserToolGroupShare[], any>({
        path: `/user-tools/${parentId}/shared-groups`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Tools
     * @name RunUserTool
     * @request POST:/user-tools/{parentId}/run
     * @secure
     */
    runUserTool: (
      parentId: string,
      data: RecordStringUnknown,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/user-tools/${parentId}/run`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  teamSchedules = {
    /**
     * @description Create a new schedule for a team
     *
     * @tags Team Schedules
     * @name CreateSchedule
     * @request POST:/teams/{teamId}/schedules
     * @secure
     */
    createSchedule: (
      teamId: string,
      data: CreateTeamScheduleRequest,
      params: RequestParams = {},
    ) =>
      this.request<TeamScheduleResponse, any>({
        path: `/teams/${teamId}/schedules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List all schedules for a team
     *
     * @tags Team Schedules
     * @name ListSchedules
     * @request GET:/teams/{teamId}/schedules
     * @secure
     */
    listSchedules: (
      teamId: string,
      query?: {
        /** @format double */
        pageSize?: number;
        /** @format double */
        pageNumber?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TeamScheduleListResponse, any>({
        path: `/teams/${teamId}/schedules`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a specific schedule by ID
     *
     * @tags Team Schedules
     * @name GetSchedule
     * @request GET:/teams/{teamId}/schedules/{scheduleId}
     * @secure
     */
    getSchedule: (
      teamId: string,
      scheduleId: string,
      params: RequestParams = {},
    ) =>
      this.request<TeamScheduleResponse, any>({
        path: `/teams/${teamId}/schedules/${scheduleId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a schedule
     *
     * @tags Team Schedules
     * @name UpdateSchedule
     * @request PUT:/teams/{teamId}/schedules/{scheduleId}
     * @secure
     */
    updateSchedule: (
      teamId: string,
      scheduleId: string,
      data: UpdateTeamScheduleRequest,
      params: RequestParams = {},
    ) =>
      this.request<TeamScheduleResponse, any>({
        path: `/teams/${teamId}/schedules/${scheduleId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a schedule
     *
     * @tags Team Schedules
     * @name DeleteSchedule
     * @request DELETE:/teams/{teamId}/schedules/{scheduleId}
     * @secure
     */
    deleteSchedule: (
      teamId: string,
      scheduleId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/teams/${teamId}/schedules/${scheduleId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  skills = {
    /**
     * No description
     *
     * @tags Skills
     * @name ListSkills
     * @request GET:/skills
     * @secure
     */
    listSkills: (params: RequestParams = {}) =>
      this.request<SkillSummaryResponse[], any>({
        path: `/skills`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Skills
     * @name CreateSkill
     * @request POST:/skills
     * @secure
     */
    createSkill: (data: CreateSkillRequest, params: RequestParams = {}) =>
      this.request<SkillResponse, any>({
        path: `/skills`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Skills
     * @name GetSkill
     * @request GET:/skills/{skillId}
     * @secure
     */
    getSkill: (skillId: string, params: RequestParams = {}) =>
      this.request<SkillResponse, any>({
        path: `/skills/${skillId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Skills
     * @name UpdateSkill
     * @request PUT:/skills/{skillId}
     * @secure
     */
    updateSkill: (
      skillId: string,
      data: UpdateSkillRequest,
      params: RequestParams = {},
    ) =>
      this.request<SkillResponse, any>({
        path: `/skills/${skillId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Skills
     * @name DeleteSkill
     * @request DELETE:/skills/{skillId}
     * @secure
     */
    deleteSkill: (skillId: string, params: RequestParams = {}) =>
      this.request<
        {
          success: boolean;
        },
        any
      >({
        path: `/skills/${skillId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Skills
     * @name ShareSkill
     * @request POST:/skills/{skillId}/share
     * @secure
     */
    shareSkill: (
      skillId: string,
      data: ShareSkillRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/skills/${skillId}/share`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Skills
     * @name UnShareSkill
     * @request POST:/skills/{skillId}/unshare
     * @secure
     */
    unShareSkill: (
      skillId: string,
      data: UnShareSkillRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/skills/${skillId}/unshare`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Skills
     * @name DuplicateSkill
     * @request POST:/skills/{skillId}/duplicate
     * @secure
     */
    duplicateSkill: (skillId: string, params: RequestParams = {}) =>
      this.request<SkillResponse, any>({
        path: `/skills/${skillId}/duplicate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Skills
     * @name GetSharedGroups
     * @request GET:/skills/{skillId}/shared-groups
     * @secure
     */
    getSharedGroups: (skillId: string, params: RequestParams = {}) =>
      this.request<SkillGroupShare[], any>({
        path: `/skills/${skillId}/shared-groups`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
